"use client";

import { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence, useInView } from "framer-motion";
import { Icon } from "./Icon";

const getAbdmSteps = (locale: string) => {
  if (locale === "hi") {
    return [
      {
        id: "m1",
        label: "M1",
        title: "ABHA बनाया गया",
        desc: "रोगी की पहचान सत्यापित और UHID से मैप की गई।",
        color: "#0A9E9A",
      },
      {
        id: "m2",
        label: "M2",
        title: "रिकॉर्ड लिंक किए गए",
        desc: "नैदानिक ​​रिकॉर्ड ABDM केयर कॉन्टेक्स्ट के रूप में लिंक किए गए।",
        color: "#2A9E5B",
      },
      {
        id: "m3",
        label: "M3",
        title: "सहमति साझा की गई",
        desc: "स्वीकृत रिकॉर्ड HIE-CM के माध्यम से सुरक्षित रूप से साझा किए गए।",
        color: "#6D28D9",
      }
    ];
  }
  return [
    {
      id: "m1",
      label: "M1",
      title: "ABHA CREATED",
      desc: "Patient identity verified and mapped with UHID.",
      color: "#0A9E9A",
    },
    {
      id: "m2",
      label: "M2",
      title: "RECORDS LINKED",
      desc: "Clinical records linked as ABDM care contexts.",
      color: "#2A9E5B",
    },
    {
      id: "m3",
      label: "M3",
      title: "CONSENT SHARED",
      desc: "Approved records securely shared via HIE-CM.",
      color: "#6D28D9",
    }
  ];
};

const getAbdmDiagramTranslations = (locale: string) => {
  if (locale === "hi") {
    return {
      registry: "रजिस्ट्री",
      secure: "सुरक्षित",
      linked: "लिंक्ड",
      hims: "HIMS",
      aadhaarOtpFlow: "आधार OTP प्रवाह",
      otpDesc: "पंजीकृत आधार मोबाइल नंबर पर भेजे गए OTP के माध्यम से सत्यापित करें।",
      fastestSelf: "सबसे तेज़ और स्वयं-सेवा",
      biometricFlow: "बायोमेट्रिक प्रवाह",
      biometricDesc: "अस्पताल डेस्क पर फिंगरप्रिंट या आइरिस स्कैनर के माध्यम से सत्यापित करें।",
      assistedNoMobile: "सहायता प्राप्त / मोबाइल की आवश्यकता नहीं",
      registrationTerminal: "पंजीकरण टर्मिनल",
      patientConsents: "रोगी सुरक्षित आधार पहचान के लिए सहमति देता है।",
      enterAadhaarOtp: "सुरक्षित आधार OTP दर्ज करें",
      waitingAadhaar: "आधार सत्यापन की प्रतीक्षा की जा रही है...",
      biometricDevice: "बायोमेट्रिक स्कैनिंग डिवाइस",
      livenessScan: "सजीवता स्कैन...",
      createPhr: "PHR पता बनाएं",
      personalHealthId: "व्यक्तिगत स्वास्थ्य रिकॉर्ड ID",
      otherSuggestions: "अन्य सुझाव",
      queryingPhr: "PHR रजिस्ट्री से पूछताछ की जा रही है...",
      linkingChikitsa: "Chikitsa HIMS से लिंक किया जा रहा है",
      establishingEncrypted: "सुरक्षित एन्क्रिप्टेड कनेक्शन स्थापित किया जा रहा है",
      abhaRegistry: "ABHA रजिस्ट्री",
      chikitsaHims: "Chikitsa HIMS",
      uhidConfigured: "मरीज का UHID कॉन्फ़िगर किया गया",
      syncingCredentials: "सुरक्षा क्रेडेंशियल सिंक किए जा रहे हैं...",
      nationalHealthAuth: "राष्ट्रीय स्वास्थ्य प्राधिकरण",
      minOfHealth: "स्वास्थ्य एवं परिवार कल्याण मंत्रालय",
      abhaFull: "ABHA (Ayushman Bharat Health Account)",
      abdmFull: "Ayushman Bharat Digital Mission (ABDM)",
      govIndia: "Govt. of India / भारत सरकार",
      vitals: "वाइटल्स",
      abhaProfile: "ABHA प्रोफाइल",
      records: "रिकॉर्ड",
      careContextLinked: "केयर कॉन्टेक्स्ट लिंक्ड",
      consentShared: "सहमति साझा की गई",
      hiuSystem: "HIU सिस्टम",
      abdmGw: "ABDM गेटवे",
      approved: "स्वीकृत",
      deny: "अस्वीकार",
      allow: "स्वीकार",
      consentRequest: "सहमति का अनुरोध",
      hipSystem: "HIP सिस्टम",
      hipServer: "HIP सर्वर",
      decisionApproved: "निर्णय: स्वीकृत",
      dischargeSummary: "डिस्चार्ज सारांश",
      encryptedDataFlow: "एन्क्रिप्टेड डेटा प्रवाह",
      encrypted: "एन्क्रिप्टेड",
      encrypting: "एन्क्रिप्ट हो रहा है",
      auditLog: "ऑडिट लॉग",
      abhaApp: "ABHA ऐप",
      selectAbhaMethod: "ABHA बनाने की विधि चुनें",
      chooseAbhaAddress: "अपना ABHA पता चुनें",
      available: "उपलब्ध!",
      otpSentTo: "पंजीकृत मोबाइल +91 98765 ••••• पर OTP भेजा गया है",
      otpVerified: "OTP सत्यापित",
      fingerprintMatch: "फिंगरप्रिंट मिलान",
      step: "कदम",
      of: "का",
    };
  }
  return {
    registry: "REGISTRY",
    secure: "SECURE",
    linked: "LINKED",
    hims: "HIMS",
    aadhaarOtpFlow: "Aadhaar OTP Flow",
    otpDesc: "Verify via OTP sent to registered Aadhaar mobile number.",
    fastestSelf: "Fastest & Self-service",
    biometricFlow: "Biometric Auth Flow",
    biometricDesc: "Verify via Fingerprint or Iris scanners at hospital desk.",
    assistedNoMobile: "Assisted / No Mobile Req.",
    registrationTerminal: "Registration Terminal",
    patientConsents: "Patient consents to secure Aadhaar identification.",
    enterAadhaarOtp: "ENTER SECURE Aadhaar OTP",
    waitingAadhaar: "Waiting for Aadhaar verification...",
    biometricDevice: "BIOMETRIC SCANNING DEVICE",
    livenessScan: "Liveness scan...",
    createPhr: "Create PHR Address",
    personalHealthId: "Personal Health Records ID",
    otherSuggestions: "OTHER SUGGESTIONS",
    queryingPhr: "Querying PHR registry...",
    linkingChikitsa: "Linking to Chikitsa HIMS",
    establishingEncrypted: "Establishing secure encrypted connection",
    abhaRegistry: "ABHA Registry",
    chikitsaHims: "Chikitsa HIMS",
    uhidConfigured: "Patient UHID Configured",
    syncingCredentials: "Syncing security credentials...",
    nationalHealthAuth: "NATIONAL HEALTH AUTHORITY",
    minOfHealth: "Ministry of Health & Family Welfare",
    abhaFull: "ABHA (Ayushman Bharat Health Account)",
    abdmFull: "Ayushman Bharat Digital Mission (ABDM)",
    govIndia: "Govt. of India / भारत सरकार",
    vitals: "VITALS",
    abhaProfile: "ABHA PROFILE",
    records: "RECORDS",
    careContextLinked: "CARE CONTEXT LINKED",
    consentShared: "CONSENT SHARED",
    hiuSystem: "HIU SYSTEM",
    abdmGw: "ABDM GW",
    approved: "APPROVED",
    deny: "DENY",
    allow: "ALLOW",
    consentRequest: "CONSENT REQUEST",
    hipSystem: "HIP SYSTEM",
    hipServer: "HIP SERVER",
    decisionApproved: "DECISION: APPROVED",
    dischargeSummary: "DISCHARGE SUMMARY",
    encryptedDataFlow: "ENCRYPTED DATA FLOW",
    encrypted: "ENCRYPTED",
    encrypting: "ENCRYPTING",
    auditLog: "AUDIT LOG",
    abhaApp: "ABHA APP",
    selectAbhaMethod: "Select ABHA Creation Method",
    chooseAbhaAddress: "Choose your ABHA Address",
    available: "Available!",
    otpSentTo: "One-Time Password has been sent to Registered Mobile +91 98765 •••••",
    otpVerified: "OTP Verified",
    fingerprintMatch: "Fingerprint Match",
    step: "Step",
    of: "of",
  };
};

const getM3StepsInfo = (locale: string) => {
  if (locale === "hi") {
    return [
      {
        title: "अनुरोध शुरू किया गया",
        desc: "HIU (अस्पताल सूचना उपयोगकर्ता) ABDM गेटवे / HIE-CM के माध्यम से रोगी के नैदानिक ​​रिकॉर्ड के लिए एक अनुरोध शुरू करता है।"
      },
      {
        title: "रोगी सत्यापन",
        desc: "गेटवे रोगी के ABHA मोबाइल ऐप पर एक सहमति अधिसूचना भेजता है, जिससे OTP/बायोमेट्रिक अनुमोदन का संकेत मिलता है।"
      },
      {
        title: "सहमति पर डिजिटल हस्ताक्षर",
        desc: "रोगी अनुरोध को मंजूरी देता है। गेटवे एक डिजिटल रूप से हस्ताक्षरित सहमति आर्टिफैक्ट उत्पन्न करता है और इसे HIP को भेजता है।"
      },
      {
        title: "EMR प्राप्त करना और एन्क्रिप्शन",
        desc: "HIP (अस्पताल सूचना प्रदाता) आर्टिफैक्ट को सत्यापित करता है, स्थानीय रिकॉर्ड प्राप्त करता है, और HIU की सार्वजनिक कुंजियों का उपयोग करके उन्हें एन्क्रिप्ट करता है।"
      },
      {
        title: "सुरक्षित स्थानांतरण और ऑडिट",
        desc: "HIP एन्क्रिप्टेड FHIR डेटा को सीधे HIU को भेजता है। स्थानांतरण घटना को लेनदेन ऑडिट बही में दर्ज किया जाता है।"
      }
    ];
  }
  return [
    {
      title: "Request Initiated",
      desc: "HIU (Hospital Information User) initiates a request for patient clinical records via the ABDM Gateway / HIE-CM."
    },
    {
      title: "Patient Verification",
      desc: "Gateway sends a consent notification to the patient's ABHA mobile app, prompting OTP/biometric approval."
    },
    {
      title: "Consent Digitally Signed",
      desc: "Patient approves the request. The Gateway generates a digitally signed Consent Artifact and routes it to the HIP."
    },
    {
      title: "EMR Fetch & Encryption",
      desc: "HIP (Hospital Information Provider) validates the artifact, fetches local records, and encrypts them using the HIU's public keys."
    },
    {
      title: "Secure Transfer & Audit",
      desc: "HIP emits the encrypted FHIR data directly to HIU. The transfer event is anchored in the transaction audit ledger."
    }
  ];
};

// Helper to draw an animated connecting line within the 600x300 viewBox
function FlowLine({ color, delay = 0, pathD }: { color: string, delay?: number, pathD: string }) {
  return (
    <>
      <path d={pathD} fill="none" stroke="rgba(11,23,51,0.06)" strokeWidth="3" strokeDasharray="6 6" />
      <motion.path
        d={pathD}
        fill="none"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        initial={{ pathLength: 0, opacity: 0 }}
        animate={{ pathLength: 1, opacity: 1 }}
        exit={{ opacity: 0, transition: { duration: 0.2 } }}
        transition={{ delay, duration: 1.2, ease: "easeInOut" }}
        style={{ filter: `drop-shadow(0 0 6px ${color}80)` }}
      />
      {/* Moving energy pulse along the line */}
      <motion.path
        d={pathD}
        fill="none"
        stroke="#fff"
        strokeWidth="3"
        strokeLinecap="round"
        initial={{ pathLength: 0, pathOffset: 0, opacity: 0 }}
        animate={{ pathLength: 0.15, pathOffset: 1, opacity: [0, 1, 0] }}
        transition={{ delay: delay + 0.8, duration: 2, ease: "linear", repeat: Infinity, repeatDelay: 0.5 }}
        style={{ filter: `drop-shadow(0 0 6px #fff)` }}
      />
    </>
  );
}

// Diagram node perfectly centered on x,y coordinates
function FlowNode({ icon, label, x, y, delay, color, children, size = 56, labelPosition = "bottom" }: { icon?: any, label: string, x: number, y: number, delay: number, color: string, children?: React.ReactNode, size?: number, labelPosition?: "top" | "bottom" | "left" | "right" }) {
  const labelStyles: React.CSSProperties = {
    position: "absolute",
    fontSize: 11, fontWeight: 800, color: "#111827", textTransform: "uppercase",
    letterSpacing: "0.06em", textAlign: "center", whiteSpace: "nowrap",
    background: "rgba(255,255,255,0.95)", padding: "4px 10px", borderRadius: 6,
    boxShadow: "0 4px 12px rgba(11,23,51,0.06)"
  };

  if (labelPosition === "bottom") {
    labelStyles.top = (size / 2) + 12;
    labelStyles.left = "50%";
    labelStyles.transform = "translateX(-50%)";
  } else if (labelPosition === "top") {
    labelStyles.bottom = (size / 2) + 12;
    labelStyles.left = "50%";
    labelStyles.transform = "translateX(-50%)";
  } else if (labelPosition === "left") {
    labelStyles.right = (size / 2) + 16;
    labelStyles.top = "50%";
    labelStyles.transform = "translateY(-50%)";
  } else if (labelPosition === "right") {
    labelStyles.left = (size / 2) + 16;
    labelStyles.top = "50%";
    labelStyles.transform = "translateY(-50%)";
  }

  return (
    <motion.div
      initial={{ scale: 0, opacity: 0, y: 10 }}
      animate={{ scale: 1, opacity: 1, y: 0 }}
      exit={{ scale: 0, opacity: 0, transition: { duration: 0.2 } }}
      transition={{ delay, type: "spring", stiffness: 320, damping: 25 }}
      style={{
        position: "absolute",
        left: `${(x / 600) * 100}%`,
        top: `${(y / 300) * 100}%`,
        zIndex: 2,
      }}
    >
      {children ? (
        <div style={{ position: "absolute", left: "50%", top: "50%", transform: "translate(-50%, -50%)" }}>
          {children}
        </div>
      ) : (
        <div
          style={{
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            width: size,
            height: size,
            borderRadius: "50%",
            background: "#fff",
            border: `3px solid ${color}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: `0 12px 24px ${color}33`,
          }}
        >
          {icon && <Icon name={icon} width={24} height={24} style={{ color }} />}
          {/* Pulse effect */}
          <motion.div
            animate={{ scale: [1, 1.4, 1], opacity: [0.5, 0, 0] }}
            transition={{ duration: 2, repeat: Infinity, delay: delay + 0.5 }}
            style={{ position: "absolute", inset: -3, borderRadius: "50%", background: color, zIndex: -1 }}
          />
        </div>
      )}
      <div style={labelStyles}>
        {label}
      </div>
    </motion.div>
  );
}

function PatientNodeMini() {
  return (
    <div style={{ width: 84, height: 60, background: "#fff", borderRadius: 10, border: "2px solid #0A9E9A", boxShadow: "0 12px 24px rgba(10,158,154,0.2)", position: "relative", overflow: "hidden", display: "flex", alignItems: "center", padding: 8, gap: 8 }}>
      <div style={{ width: 32, height: 40, background: "rgba(10,158,154,0.1)", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Icon name="user" width={20} height={20} style={{ color: "#0A9E9A" }} />
      </div>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 6 }}>
        <div style={{ width: "100%", height: 6, background: "#0A9E9A", borderRadius: 3 }} />
        <div style={{ width: "70%", height: 6, background: "rgba(10,158,154,0.3)", borderRadius: 3 }} />
        <div style={{ width: "40%", height: 6, background: "rgba(10,158,154,0.3)", borderRadius: 3 }} />
      </div>
      {/* Scanning laser */}
      <motion.div
        animate={{ y: [-10, 70, -10] }}
        transition={{ duration: 2.5, repeat: Infinity, ease: "linear" }}
        style={{ position: "absolute", left: 0, right: 0, top: 0, height: 3, background: "#0A9E9A", boxShadow: "0 0 12px #0A9E9A", opacity: 0.8 }}
      />
    </div>
  );
}

function EmrNodeMini() {
  return (
    <div style={{ width: 80, height: 80, background: "#fff", borderRadius: 12, border: "2px solid #0A9E9A", boxShadow: "0 12px 24px rgba(10,158,154,0.2)", overflow: "hidden", display: "flex", flexDirection: "column" }}>
      <div style={{ height: 20, background: "#0A9E9A", display: "flex", alignItems: "center", padding: "0 8px", gap: 5 }}>
        <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#fff", opacity: 0.8 }} />
        <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#fff", opacity: 0.8 }} />
      </div>
      <div style={{ flex: 1, padding: 8, display: "flex", flexDirection: "column", gap: 8, justifyContent: "center" }}>
        <motion.div animate={{ opacity: [0.3, 1, 0.3] }} transition={{ duration: 1.5, delay: 0.2, repeat: Infinity }} style={{ width: "100%", height: 8, background: "rgba(10,158,154,0.2)", borderRadius: 4 }} />
        <motion.div animate={{ opacity: [0.3, 1, 0.3] }} transition={{ duration: 1.5, delay: 0.6, repeat: Infinity }} style={{ width: "80%", height: 8, background: "rgba(10,158,154,0.2)", borderRadius: 4 }} />
        <motion.div animate={{ opacity: [0.3, 1, 0.3] }} transition={{ duration: 1.5, delay: 1.0, repeat: Infinity }} style={{ width: "90%", height: 8, background: "rgba(10,158,154,0.2)", borderRadius: 4 }} />
      </div>
    </div>
  );
}

function AbhaVerifiedNodeMini() {
  return (
    <div style={{ width: 80, height: 80, background: "#0A9E9A", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 12px 32px rgba(10,158,154,0.4)", position: "relative" }}>
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1.2, type: "spring" }}
      >
        <Icon name="check" width={40} height={40} style={{ color: "#fff" }} />
      </motion.div>
      {/* Rotating ring */}
      <motion.svg
        animate={{ rotate: 360 }}
        transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
        style={{ position: "absolute", inset: -8, width: "calc(100% + 16px)", height: "calc(100% + 16px)", overflow: "visible" }}
      >
        <circle cx="50%" cy="50%" r="44" fill="none" stroke="rgba(10,158,154,0.3)" strokeWidth="3" strokeDasharray="10 10" />
      </motion.svg>
    </div>
  );
}

function AbhaRegistryNodeMini({ t }: { t: ReturnType<typeof getAbdmDiagramTranslations> }) {
  return (
    <div style={{
      width: 80,
      height: 80,
      background: "#fff",
      borderRadius: 14,
      border: "2px solid #0A9E9A",
      boxShadow: "0 12px 24px rgba(10,158,154,0.15)",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      position: "relative"
    }}>
      {/* Top status bar */}
      <div style={{ height: 18, background: "#0A9E9A", display: "flex", alignItems: "center", padding: "0 8px", justifyContent: "space-between" }}>
        <span style={{ fontSize: 8, color: "#fff", fontWeight: 900, letterSpacing: "0.05em" }}>{t.registry}</span>
        <motion.div
          animate={{ opacity: [0.3, 1, 0.3] }}
          transition={{ duration: 1, repeat: Infinity }}
          style={{ width: 5, height: 5, borderRadius: "50%", background: "#5EEAD4", boxShadow: "0 0 6px #5EEAD4" }}
        />
      </div>

      {/* Server & DB stack visualization */}
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: 6, gap: 6 }}>
        {/* Left rack: server icons stacking */}
        <div style={{ display: "flex", flexDirection: "column", gap: 3, flex: 1, alignItems: "center" }}>
          {/* Server Unit 1 */}
          <div style={{ width: "100%", height: 14, background: "rgba(10,158,154,0.05)", border: "1px solid rgba(10,158,154,0.2)", borderRadius: 3, display: "flex", alignItems: "center", padding: "0 3px", gap: 2 }}>
            <div style={{ width: 2, height: 2, borderRadius: "50%", background: "#0A9E9A" }} />
            <div style={{ flex: 1, height: 1.5, background: "rgba(10,158,154,0.2)", borderRadius: 1 }} />
            <motion.div animate={{ opacity: [0.3, 1, 0.3] }} transition={{ duration: 0.8, repeat: Infinity, delay: 0.1 }} style={{ width: 3, height: 3, borderRadius: "50%", background: "#10B981" }} />
          </div>
          {/* Server Unit 2 */}
          <div style={{ width: "100%", height: 14, background: "rgba(10,158,154,0.05)", border: "1px solid rgba(10,158,154,0.2)", borderRadius: 3, display: "flex", alignItems: "center", padding: "0 3px", gap: 2 }}>
            <div style={{ width: 2, height: 2, borderRadius: "50%", background: "#0A9E9A" }} />
            <div style={{ flex: 1, height: 1.5, background: "rgba(10,158,154,0.2)", borderRadius: 1 }} />
            <motion.div animate={{ opacity: [0.3, 1, 0.3] }} transition={{ duration: 1.2, repeat: Infinity, delay: 0.4 }} style={{ width: 3, height: 3, borderRadius: "50%", background: "#10B981" }} />
          </div>
          {/* Server Unit 3 */}
          <div style={{ width: "100%", height: 14, background: "rgba(10,158,154,0.05)", border: "1px solid rgba(10,158,154,0.2)", borderRadius: 3, display: "flex", alignItems: "center", padding: "0 3px", gap: 2 }}>
            <div style={{ width: 2, height: 2, borderRadius: "50%", background: "#0A9E9A" }} />
            <div style={{ flex: 1, height: 1.5, background: "rgba(10,158,154,0.2)", borderRadius: 1 }} />
            <motion.div animate={{ opacity: [0.3, 1, 0.3] }} transition={{ duration: 1.0, repeat: Infinity, delay: 0.7 }} style={{ width: 3, height: 3, borderRadius: "50%", background: "#10B981" }} />
          </div>
        </div>

        {/* Database circular radar or emblem */}
        <div style={{ width: 28, height: 28, position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Icon name="server" width={16} height={16} style={{ color: "#0A9E9A", zIndex: 2 }} />
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 6, repeat: Infinity, ease: "linear" }}
            style={{
              position: "absolute",
              inset: 0,
              borderRadius: "50%",
              border: "1px dashed rgba(10, 158, 154, 0.5)",
              zIndex: 1
            }}
          />
        </div>
      </div>
    </div>
  );
}

function LocalHimsNodeMini({ linkingProgress, t }: { linkingProgress: number; t: ReturnType<typeof getAbdmDiagramTranslations> }) {
  const isLinked = linkingProgress === 100;

  return (
    <div style={{
      width: 80,
      height: 80,
      background: "#fff",
      borderRadius: 14,
      border: `2px solid ${isLinked ? "#10B981" : "rgba(10, 158, 154, 0.25)"}`,
      boxShadow: isLinked ? "0 12px 24px rgba(16,185,129,0.2)" : "0 12px 24px rgba(11,23,51,0.03)",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      position: "relative",
      transition: "all 0.4s ease"
    }}>
      {/* Top status bar */}
      <div style={{
        height: 18,
        background: isLinked ? "#10B981" : "rgba(10, 158, 154, 0.15)",
        display: "flex",
        alignItems: "center",
        padding: "0 8px",
        justifyContent: "space-between",
        transition: "all 0.4s ease"
      }}>
        <span style={{
          fontSize: 8,
          color: isLinked ? "#fff" : "#4B5563",
          fontWeight: 900,
          letterSpacing: "0.05em",
          transition: "all 0.4s ease"
        }}>
          {isLinked ? t.linked : t.hims}
        </span>
        {/* Connection state LED */}
        <motion.div
          animate={isLinked ? { scale: [1, 1.3, 1], opacity: 1 } : { opacity: [0.4, 1, 0.4] }}
          transition={{ duration: 1.2, repeat: Infinity }}
          style={{
            width: 5,
            height: 5,
            borderRadius: "50%",
            background: isLinked ? "#fff" : "#FFB020",
            boxShadow: isLinked ? "0 0 6px #fff" : "0 0 6px #FFB020"
          }}
        />
      </div>

      {/* Internal layout */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", padding: 6, justifyContent: "center", gap: 4, position: "relative" }}>
        {isLinked ? (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", gap: 2 }}>
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ type: "spring", stiffness: 200, damping: 15 }}
            >
              <Icon name="shield" width={24} height={24} style={{ color: "#10B981" }} />
            </motion.div>
            <span style={{ fontSize: 8, color: "#10B981", fontWeight: 800 }}>{t.secure}</span>
          </div>
        ) : (
          <div style={{ display: "flex", alignItems: "center", gap: 6, height: "100%" }}>
            {/* HIMS Shield icon */}
            <div style={{ width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(10, 158, 154, 0.05)", borderRadius: 5, border: "1px solid rgba(10, 158, 154, 0.2)" }}>
              <Icon name="shield" width={14} height={14} style={{ color: "#0A9E9A" }} />
            </div>

            {/* Visual mapping/loading bars */}
            <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 3 }}>
              <motion.div
                animate={{ width: ["20%", "90%", "20%"] }}
                transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                style={{ height: 3, background: "rgba(10, 158, 154, 0.3)", borderRadius: 1.5 }}
              />
              <motion.div
                animate={{ width: ["40%", "70%", "40%"] }}
                transition={{ duration: 2, repeat: Infinity, ease: "easeInOut", delay: 0.3 }}
                style={{ height: 3, background: "rgba(10, 158, 154, 0.15)", borderRadius: 1.5 }}
              />
              <motion.div
                animate={{ width: ["10%", "85%", "10%"] }}
                transition={{ duration: 2, repeat: Infinity, ease: "easeInOut", delay: 0.6 }}
                style={{ height: 3, background: "rgba(10, 158, 154, 0.2)", borderRadius: 1.5 }}
              />
            </div>
          </div>
        )}
      </div>

      {/* Success Pulse Ring overlays */}
      {isLinked && (
        <>
          <motion.div
            animate={{ scale: [0.8, 1.4], opacity: [0.4, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
            style={{ position: "absolute", inset: 0, borderRadius: 14, border: "2px solid #10B981", pointerEvents: "none" }}
          />
        </>
      )}
    </div>
  );
}

interface ScannerProps {
  progress: number;
  success: boolean;
}

function DermalFingerprintScanner({ progress, success }: ScannerProps) {
  const strokeColor = success ? "#10B981" : "#0A9E9A";

  return (
    <div style={{
      width: 130,
      height: 130,
      borderRadius: 22,
      border: `2px solid ${success ? "rgba(16, 185, 129, 0.4)" : "rgba(10, 158, 154, 0.25)"}`,
      background: "#ffffff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      overflow: "hidden",
      boxShadow: success
        ? "0 0 30px rgba(16, 185, 129, 0.15), inset 0 2px 10px rgba(0,0,0,0.02)"
        : "0 0 25px rgba(10, 158, 154, 0.1), inset 0 2px 10px rgba(0,0,0,0.02)",
      transition: "all 0.4s ease"
    }}>
      {/* Grid Pattern Background */}
      <div style={{
        position: "absolute",
        inset: 0,
        opacity: 0.05,
        backgroundImage: "linear-gradient(to right, #0A9E9A 1px, transparent 1px), linear-gradient(to bottom, #0A9E9A 1px, transparent 1px)",
        backgroundSize: "10px 10px"
      }} />

      {/* The Fingerprint SVG Container */}
      <div style={{ position: "relative", zIndex: 2 }}>
        <svg width="68" height="68" viewBox="0 0 24 24" fill="none" stroke={strokeColor} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" style={{ display: "block", position: "relative", filter: success ? "drop-shadow(0 0 8px rgba(16, 185, 129, 0.7))" : "drop-shadow(0 0 6px rgba(10, 158, 154, 0.4))", transition: "stroke 0.4s ease" }}>
          <defs>
            <clipPath id="biometric-scan-clip">
              <rect x="0" y="0" width="24" height={(progress / 100) * 24} />
            </clipPath>
          </defs>

          {/* Background print (unscanned / dim) */}
          <g stroke="rgba(10, 158, 154, 0.15)">
            <path d="M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4" /><path d="M14 13.12c0 2.38 0 6.38-1 8.88" /><path d="M17.29 21.02c.12-.6.43-2.3.5-3.02" /><path d="M2 12a10 10 0 0 1 18-6" /><path d="M2 16h.01" /><path d="M21.8 16c.2-2 .131-5.354 0-6" /><path d="M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2" /><path d="M8.65 22c.21-.66.45-1.32.57-2" /><path d="M9 6.8a6 6 0 0 1 9 5.2v2" />
          </g>

          {/* Foreground print (glowing, revealed by clip-path progress) */}
          <g clipPath="url(#biometric-scan-clip)" stroke={strokeColor} style={{ transition: "stroke 0.4s ease" }}>
            <path d="M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4" /><path d="M14 13.12c0 2.38 0 6.38-1 8.88" /><path d="M17.29 21.02c.12-.6.43-2.3.5-3.02" /><path d="M2 12a10 10 0 0 1 18-6" /><path d="M2 16h.01" /><path d="M21.8 16c.2-2 .131-5.354 0-6" /><path d="M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2" /><path d="M8.65 22c.21-.66.45-1.32.57-2" /><path d="M9 6.8a6 6 0 0 1 9 5.2v2" />
          </g>
        </svg>
      </div>

      {/* Scanner laser bar sweeps up and down */}
      {!success && (
        <motion.div
          animate={{ top: ["4%", "92%", "4%"] }}
          transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut" }}
          style={{
            position: "absolute",
            left: 8,
            right: 8,
            height: 3,
            background: "linear-gradient(90deg, transparent, #0A9E9A 30%, #5EEAD4 50%, #0A9E9A 70%, transparent)",
            boxShadow: "0 0 12px #0A9E9A, 0 0 4px #fff",
            zIndex: 3
          }}
        />
      )}

      {/* Success Pulse Rings */}
      {success && (
        <>
          <div style={{ position: "absolute", inset: 0, background: "rgba(16, 185, 129, 0.08)" }} />
          <motion.div
            animate={{ scale: [0.8, 1.5], opacity: [0.6, 0] }}
            transition={{ duration: 1.6, repeat: Infinity, ease: "easeOut" }}
            style={{ position: "absolute", width: "100%", height: "100%", borderRadius: "50%", border: "2px solid #10B981" }}
          />
        </>
      )}
    </div>
  );
}

// Log formatting utilities for the high-tech terminal outputs
const getBiometricLog = (prog: number, locale = "en") => {
  if (locale === "hi") {
    if (prog === 0) return "> सुरक्षित हार्डवेयर प्रारंभ हो रहा है...";
    if (prog < 25) return "> त्वचीय रिज घनत्व स्कैन किया जा रहा है...";
    if (prog < 55) return "> त्वचीय संवहनी पैटर्न पढ़ा जा रहा है...";
    if (prog < 80) return "> मरीज की जीवंतता मानचित्र का विश्लेषण हो रहा है...";
    if (prog < 100) return "> आधार वॉल्ट से प्रमाणीकरण हो रहा है...";
    return ">> सत्यापन सफल (मिलान: 99.4%)";
  }
  if (prog === 0) return "> INITIALIZING SECURE HARDWARE...";
  if (prog < 25) return "> SCANNING DERMAL RIDGE DENSITY...";
  if (prog < 55) return "> READING DERMAL VASCULAR PATTERN...";
  if (prog < 80) return "> ANALYZING PATIENT LIVENESS MAP...";
  if (prog < 100) return "> AUTHENTICATING WITH AADHAAR VAULT...";
  return ">> VERIFICATION SUCCESSFUL (MATCH: 99.4%)";
};

const getLinkingLog = (prog: number, locale = "en") => {
  if (locale === "hi") {
    if (prog === 0) return "> Chikitsa EMR के साथ हैंडशेक स्थापित हो रहा है...";
    if (prog < 35) return "> हैंडशेक क्रेडेंशियल सुरक्षित हो रहे हैं...";
    if (prog < 70) return "> राष्ट्रीय स्वास्थ्य रजिस्ट्री से पूछताछ हो रही है...";
    if (prog < 100) return "> ABHA केयर कॉन्टेक्स्ट संदर्भ बनाया जा रहा है...";
    return ">> रिकॉर्ड मैप किए गए: UHID CH-2026-8942 कॉन्फ़िगर किया गया";
  }
  if (prog === 0) return "> ESTABLISHING HANDSHAKE WITH CHIKITSA EMR...";
  if (prog < 35) return "> SECURING HANDSHAKE CREDENTIALS...";
  if (prog < 70) return "> QUERYING NATIONAL HEALTH REGISTRY...";
  if (prog < 100) return "> GENERATING ABHA CARE CONTEXT REFERENCE...";
  return ">> RECORDS MAPPED: UHID CH-2026-8942 CONFIGURED";
};


function MicroConfetti() {
  const particles = Array.from({ length: 45 });
  return (
    <div style={{ position: "absolute", inset: 0, pointerEvents: "none", zIndex: 10, overflow: "hidden" }}>
      {particles.map((_, i) => {
        const angle = (i / particles.length) * 360 + Math.random() * 20;
        const radius = 90 + Math.random() * 110;
        const x = Math.cos((angle * Math.PI) / 180) * radius;
        const y = Math.sin((angle * Math.PI) / 180) * radius - 40;
        const size = i % 2 === 0 ? 4 + Math.random() * 4 : 2 + Math.random() * 6;
        const color = ["#FF7A00", "#FFC837", "#0A9E9A", "#10B981", "#6D28D9", "#EF4444", "#3B82F6"][i % 7];
        return (
          <motion.div
            key={i}
            initial={{ x: 0, y: 50, opacity: 1, scale: 0.3, rotate: 0 }}
            animate={{
              x: x,
              y: y,
              opacity: [1, 1, 0],
              scale: [0.3, 1.4, 0],
              rotate: angle * 4
            }}
            transition={{ duration: 2.0, ease: "easeOut", delay: (i % 5) * 0.05 }}
            style={{
              position: "absolute",
              left: "50%",
              top: "50%",
              width: size,
              height: size,
              borderRadius: i % 3 === 0 ? "50%" : i % 3 === 1 ? "0%" : "2px",
              background: color,
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
            }}
          />
        );
      })}
    </div>
  );
}

function FingerprintSVG({ strokeColor = "#0A9E9A" }: { strokeColor?: string }) {
  return (
    <div style={{ color: strokeColor }}>
      <Icon name="fingerprint" width={22} height={22} />
    </div>
  );
}

function DiagramM1({ onInteractionStart, onInteractionReset, onComplete, isHovered, isInteracting, isInView, locale = "en" }: { onInteractionStart: () => void; onInteractionReset: () => void; onComplete?: () => void; isHovered?: boolean; isInteracting?: boolean; isInView?: boolean; locale?: string }) {
  const t = getAbdmDiagramTranslations(locale);
  const [method, setMethod] = useState<"otp" | "biometric">("otp");
  const [simStep, setSimStep] = useState<number>(0);
  const [isPlaying, setIsPlaying] = useState<boolean>(true);

  // Input states
  const [aadhaarText, setAadhaarText] = useState("");
  const [contactText, setContactText] = useState("");
  const [otpEntered, setOtpEntered] = useState<string[]>(["", "", "", "", "", ""]);
  const [biometricProgress, setBiometricProgress] = useState(0);
  const [abhaText, setAbhaText] = useState("");
  const [linkingProgress, setLinkingProgress] = useState(0);
  const [downloading, setDownloading] = useState(false);
  const [downloadSuccess, setDownloadSuccess] = useState(false);

  // Active OTP digit index for caret animation
  const activeOtpIndex = otpEntered.findIndex(d => d === "");

  // Auto-play flow loop
  useEffect(() => {
    if (!isPlaying || !isInView || isInteracting) return;

    let timerId: NodeJS.Timeout | undefined;
    let intervalId: NodeJS.Timeout | undefined;

    if (simStep === 0) {
      timerId = setTimeout(() => {
        setSimStep(1);
      }, 3000);
    } else if (simStep === 1) {
      setAadhaarText("");
      setContactText("");
      const aadhaarFull = "5543 8920 XXXX";
      const contactFull = "98765 43210";
      let curAadhaar = "";
      let curContact = "";
      let idx = 0;

      intervalId = setInterval(() => {
        if (idx < aadhaarFull.length) {
          curAadhaar += aadhaarFull[idx];
          setAadhaarText(curAadhaar);
          idx++;
        } else if (idx < aadhaarFull.length + contactFull.length) {
          const contactIdx = idx - aadhaarFull.length;
          curContact += contactFull[contactIdx];
          setContactText(curContact);
          idx++;
        } else {
          if (intervalId) clearInterval(intervalId);
          timerId = setTimeout(() => {
            setSimStep(2);
          }, 2500);
        }
      }, 80);
    } else if (simStep === 2) {
      setOtpEntered(["", "", "", "", "", ""]);
      setBiometricProgress(0);
      const otpFull = "482019";
      let otpIdx = 0;
      let bioProgress = 0;

      intervalId = setInterval(() => {
        let isDone = true;

        // Progress OTP
        if (otpIdx < otpFull.length) {
          isDone = false;
          if (bioProgress % 12 === 0) {
            otpIdx++;
            const newOtp = ["", "", "", "", "", ""];
            for (let i = 0; i < otpIdx; i++) {
              newOtp[i] = otpFull[i];
            }
            setOtpEntered(newOtp);
          }
        }

        // Progress Biometric
        if (bioProgress < 100) {
          isDone = false;
          bioProgress += 2;
          if (bioProgress > 100) bioProgress = 100;
          setBiometricProgress(bioProgress);
        }

        if (isDone) {
          if (intervalId) clearInterval(intervalId);
          timerId = setTimeout(() => {
            setSimStep(3);
          }, 3000);
        }
      }, 60);
    } else if (simStep === 3) {
      setAbhaText("");
      const abhaFull = "rahul.sharma";
      let curAbha = "";
      let idx = 0;

      intervalId = setInterval(() => {
        if (idx < abhaFull.length) {
          curAbha += abhaFull[idx];
          setAbhaText(curAbha);
          idx++;
        } else {
          if (intervalId) clearInterval(intervalId);
          timerId = setTimeout(() => {
            setSimStep(4);
          }, 2500);
        }
      }, 90);
    } else if (simStep === 4) {
      setLinkingProgress(0);
      let progress = 0;

      intervalId = setInterval(() => {
        if (progress < 100) {
          progress += 2;
          if (progress > 100) progress = 100;
          setLinkingProgress(progress);
        } else {
          if (intervalId) clearInterval(intervalId);
          timerId = setTimeout(() => {
            setSimStep(5);
          }, 2500);
        }
      }, 50);
    } else if (simStep === 5) {
      timerId = setTimeout(() => {
        if (onComplete) {
          onComplete();
        } else {
          setSimStep(0);
        }
      }, 3000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
      if (timerId) clearTimeout(timerId);
    };
  }, [simStep, isPlaying, isHovered, isInteracting, onComplete, isInView]);

  const handleDownload = () => {
    setDownloading(true);
    setTimeout(() => {
      setDownloading(false);
      setDownloadSuccess(true);
      setTimeout(() => setDownloadSuccess(false), 2000);
    }, 1500);
  };

  const SIM_STEPS = locale === "hi" 
    ? ["विधि", "विवरण", "सत्यापन", "PHR पता", "लिंक करें", "ABHA कार्ड"] 
    : ["Method", "Details", "Verify", "PHR Address", "Link", "ABHA Card"];

  return (
    <div style={{ width: "100%", height: "100%", position: "relative", display: "flex", flexDirection: "column", color: "#111827", fontFamily: "var(--font-sans), sans-serif", fontSize: 13 }}>
      <style>{`
        @keyframes scan-laser {
          0% { top: 4%; opacity: 0.9; }
          50% { top: 96%; opacity: 0.9; }
          100% { top: 4%; opacity: 0.9; }
        }
        @keyframes pulse-ring {
          0% { transform: scale(0.95); opacity: 0.7; }
          50% { transform: scale(1.4); opacity: 0.2; }
          100% { transform: scale(0.95); opacity: 0; }
        }
        @keyframes border-glow-neon {
          0% { border-color: rgba(10, 158, 154, 0.25); box-shadow: 0 0 8px rgba(10, 158, 154, 0.05); }
          50% { border-color: rgba(10, 158, 154, 0.75); box-shadow: 0 0 16px rgba(10, 158, 154, 0.25); }
          100% { border-color: rgba(10, 158, 154, 0.25); box-shadow: 0 0 8px rgba(10, 158, 154, 0.05); }
        }
        @keyframes rotate-chakra {
          0% { transform: translate(-50%, -50%) rotate(0deg); }
          100% { transform: translate(-50%, -50%) rotate(360deg); }
        }
        @keyframes otp-caret {
          0% { opacity: 0; }
          50% { opacity: 1; }
          100% { opacity: 0; }
        }
        @keyframes dash-flow {
          to { stroke-dashoffset: -20; }
        }
        .holo-card-premium {
          position: relative;
          overflow: hidden;
          transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
          transform-style: preserve-3d;
          perspective: 800px;
        }
        .holo-card-premium::after {
          content: '';
          position: absolute;
          top: -150%; left: -150%; width: 300%; height: 300%;
          background: linear-gradient(115deg, transparent 40%, rgba(255,255,255,0.2) 47%, rgba(255,255,255,0.38) 50%, rgba(255,255,255,0.2) 53%, transparent 60%);
          opacity: 0.15;
          transition: opacity 0.4s;
          pointer-events: none;
          transform: rotate(-15deg);
        }
        .holo-card-premium:hover {
          transform: rotateY(5deg) rotateX(3deg) scale(1.015);
          box-shadow: 0 25px 50px rgba(11,23,51,0.16), inset 0 1px 0 #fff;
        }
        .holo-card-premium:hover::after {
          opacity: 0.6;
          animation: holo-slide-premium 2s ease-in-out infinite;
        }
        @keyframes holo-slide-premium {
          0% { transform: translate(-15%, -15%) rotate(-15deg); }
          100% { transform: translate(15%, 15%) rotate(-15deg); }
        }
        @media (max-width: 600px) {
          .hide-mobile { display: none !important; }
        }
      `}</style>

      {/* Mini Stepper */}
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 16, borderBottom: "1px solid rgba(11,23,51,0.06)", paddingBottom: 8 }}>
        {SIM_STEPS.map((s, idx) => {
          const isCompleted = idx < simStep;
          const isCurrent = idx === simStep;
          return (
            <button
              key={s}
              onClick={() => {
                onInteractionStart();
                setSimStep(idx);
                if (idx > 1) {
                  setAadhaarText("5543 8920 1198");
                  setContactText("98765 43210");
                }
                if (idx > 2) {
                  setOtpEntered(["4", "8", "2", "0", "1", "9"]);
                  setBiometricProgress(100);
                }
                if (idx > 3) {
                  setAbhaText("rahul.sharma");
                }
                if (idx > 4) {
                  setLinkingProgress(100);
                }
              }}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: 10,
                fontWeight: 700,
                color: isCurrent ? "#0A9E9A" : isCompleted ? "#10B981" : "#9CA3AF",
                display: "flex",
                alignItems: "center",
                gap: 4,
                padding: "2px 6px",
                borderRadius: 4,
                transition: "all 0.2s ease"
              }}
            >
              <div style={{
                width: 14, height: 14, borderRadius: "50%",
                background: isCurrent ? "#0A9E9A" : isCompleted ? "#10B981" : "transparent",
                border: `1.5px solid ${isCurrent || isCompleted ? "transparent" : "#D1D5DB"}`,
                color: isCurrent || isCompleted ? "#fff" : "#9CA3AF",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 8, fontWeight: 900
              }}>
                {isCompleted ? "✓" : idx + 1}
              </div>
              <span className="hide-mobile">{s}</span>
            </button>
          );
        })}
      </div>

      {/* Main Panel Content */}
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", minHeight: 240, position: "relative" }}>
        <AnimatePresence mode="wait">
          {simStep === 0 && (
            <motion.div
              key="step0"
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.3 }}
              style={{ width: "100%", display: "flex", flexDirection: "column", gap: 16, alignItems: "center" }}
            >
              <h4 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: "#111827", textAlign: "center" }}>{t.selectAbhaMethod}</h4>
              <div style={{ display: "flex", gap: 16, width: "100%", flexWrap: "wrap", justifyContent: "center" }}>
                {/* Method 1: Aadhaar OTP */}
                <div
                  style={{
                    flex: "1 1 180px", maxWidth: 220, padding: 18, borderRadius: 16, border: "2.5px solid rgba(10, 158, 154, 0.18)",
                    background: "#fff", display: "flex", flexDirection: "column",
                    alignItems: "flex-start", gap: 8, textAlign: "left", boxShadow: "0 8px 16px rgba(11,23,51,0.03)"
                  }}
                >
                  <div style={{ width: 38, height: 38, borderRadius: 12, background: "rgba(10, 158, 154, 0.08)", display: "flex", alignItems: "center", justifyContent: "center", color: "#0A9E9A" }}>
                    <Icon name="phone" width={22} height={22} style={{ color: "#0A9E9A" }} />
                  </div>
                  <span style={{ fontSize: 13, fontWeight: 700, color: "#111827" }}>{t.aadhaarOtpFlow}</span>
                  <span style={{ fontSize: 11, color: "#6B7280", lineHeight: 1.45 }}>{t.otpDesc}</span>
                  <span style={{ fontSize: 9, background: "rgba(10, 158, 154, 0.12)", color: "#0A9E9A", fontWeight: 800, padding: "3px 9px", borderRadius: 999, marginTop: 4 }}>{t.fastestSelf}</span>
                </div>

                {/* OR Divider */}
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 8, padding: "0 8px" }}>
                  <div style={{ width: 1, height: 40, borderLeft: "1.5px dashed #D1D5DB" }} />
                  <span style={{ fontSize: 10, fontWeight: 800, color: "#9CA3AF", background: "#F3F4F6", padding: "4px 8px", borderRadius: 12 }}>OR</span>
                  <div style={{ width: 1, height: 40, borderLeft: "1.5px dashed #D1D5DB" }} />
                </div>

                {/* Method 2: Biometric */}
                <div
                  style={{
                    flex: "1 1 180px", maxWidth: 220, padding: 18, borderRadius: 16, border: "2.5px solid rgba(10, 158, 154, 0.18)",
                    background: "#fff", display: "flex", flexDirection: "column",
                    alignItems: "flex-start", gap: 8, textAlign: "left", boxShadow: "0 8px 16px rgba(11,23,51,0.03)"
                  }}
                >
                  <div style={{ width: 38, height: 38, borderRadius: 12, background: "rgba(10, 158, 154, 0.08)", display: "flex", alignItems: "center", justifyContent: "center", color: "#0A9E9A" }}>
                    <FingerprintSVG strokeColor="#0A9E9A" />
                  </div>
                  <span style={{ fontSize: 13, fontWeight: 700, color: "#111827" }}>{t.biometricFlow}</span>
                  <span style={{ fontSize: 11, color: "#6B7280", lineHeight: 1.45 }}>{t.biometricDesc}</span>
                  <span style={{ fontSize: 9, background: "rgba(109, 40, 217, 0.08)", color: "#6D28D9", fontWeight: 800, padding: "3px 9px", borderRadius: 999, marginTop: 4 }}>{t.assistedNoMobile}</span>
                </div>
              </div>
            </motion.div>
          )}

          {simStep === 1 && (
            <motion.div
              key="step1"
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.3 }}
              style={{ width: "100%", maxWidth: 380, background: "#fff", border: "1px solid rgba(11,23,51,0.06)", borderRadius: 16, padding: 20, boxShadow: "0 16px 32px rgba(11,23,51,0.04)" }}
            >
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: 12 }}>
                <span style={{ fontWeight: 800, color: "#111827", fontSize: 13, letterSpacing: "0.06em", textTransform: "uppercase" }}>{t.registrationTerminal}</span>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                <div>
                  <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#4B5563", marginBottom: 5 }}>Aadhaar Number / आधार संख्या</label>
                  <div style={{ width: "100%", height: 38, background: "#F9FAFB", border: "1.5px solid #E5E7EB", borderRadius: 8, padding: "8px 14px", display: "flex", alignItems: "center", gap: 10, position: "relative" }}>
                    <Icon name="idCard" width={16} height={16} style={{ color: "#9CA3AF" }} />
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span style={{ fontFamily: "var(--font-mono), monospace", letterSpacing: "0.06em", fontSize: 13, color: "#111827", fontWeight: 500 }}>{aadhaarText}</span>
                      {aadhaarText.length < 14 && isPlaying && (
                        <motion.div animate={{ opacity: [0, 1, 0] }} transition={{ duration: 0.8, repeat: Infinity }} style={{ width: 1.8, height: 16, background: "#0A9E9A", marginLeft: 2 }} />
                      )}
                    </div>
                  </div>
                </div>
                <div>
                  <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#4B5563", marginBottom: 5 }}>Contact Number / संपर्क संख्या</label>
                  <div style={{ width: "100%", height: 38, background: "#F9FAFB", border: "1.5px solid #E5E7EB", borderRadius: 8, padding: "8px 14px", display: "flex", alignItems: "center", gap: 10, position: "relative" }}>
                    <Icon name="phone" width={16} height={16} style={{ color: "#9CA3AF" }} />
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span style={{ fontFamily: "var(--font-mono), monospace", letterSpacing: "0.06em", fontSize: 13, color: "#111827", fontWeight: 500 }}>{contactText}</span>
                      {aadhaarText.length === 14 && contactText.length < 11 && isPlaying && (
                        <motion.div animate={{ opacity: [0, 1, 0] }} transition={{ duration: 0.8, repeat: Infinity }} style={{ width: 1.8, height: 16, background: "#0A9E9A", marginLeft: 2 }} />
                      )}
                    </div>
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 4 }}>
                  <div style={{ width: 15, height: 15, borderRadius: 4, border: "1.5px solid #0A9E9A", background: "#EBF8F7", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Icon name="check" width={10} height={10} style={{ color: "#0A9E9A" }} />
                  </div>
                  <span style={{ fontSize: 11, color: "#6B7280" }}>{t.patientConsents}</span>
                </div>
              </div>
            </motion.div>
          )}

          {simStep === 2 && (
            <motion.div
              key="step2"
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.3 }}
              style={{ width: "100%", maxWidth: 680, background: "#fff", border: "1px solid rgba(11,23,51,0.06)", borderRadius: 16, padding: 24, boxShadow: "0 16px 32px rgba(11,23,51,0.04)" }}
            >
              <div style={{ display: "flex", alignItems: "stretch", justifyContent: "center", gap: 16, flexWrap: "nowrap" }}>

                {/* Left Side: OTP */}
                <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 14, minWidth: 200 }}>
                  <span style={{ fontWeight: 800, color: "#4B5563", fontSize: 11, letterSpacing: "0.08em" }}>{t.enterAadhaarOtp}</span>
                  <p style={{ margin: 0, fontSize: 11, color: "#6B7280", textAlign: "center", lineHeight: 1.4 }}>{t.otpSentTo}</p>

                  {/* OTP Digit Boxes */}
                  <div style={{ display: "flex", gap: 6, margin: "8px 0" }}>
                    {otpEntered.map((digit, i) => {
                      const isCurrent = i === activeOtpIndex;
                      return (
                        <div key={i} style={{
                          width: 32, height: 38, border: `2px solid ${isCurrent ? "#0A9E9A" : digit ? "#10B981" : "#E5E7EB"}`,
                          borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center",
                          fontSize: 16, fontWeight: 800, background: digit ? "rgba(16, 185, 129, 0.03)" : "#F9FAFB",
                          boxShadow: isCurrent ? "0 0 10px rgba(10, 158, 154, 0.2)" : "none",
                          transition: "all 0.2s ease", position: "relative", color: "#111827"
                        }}>
                          {digit}
                          {isCurrent && isPlaying && (
                            <span style={{ position: "absolute", width: 1.5, height: 16, background: "#0A9E9A", animation: "otp-caret 0.8s infinite" }} />
                          )}
                        </div>
                      );
                    })}
                  </div>

                  {otpEntered[5] !== "" ? (
                    <motion.div
                      initial={{ scale: 0.9, opacity: 0 }}
                      animate={{ scale: 1, opacity: 1 }}
                      style={{ display: "flex", alignItems: "center", gap: 6, color: "#10B981", fontWeight: 800, fontSize: 12, background: "#E6F4EA", padding: "6px 16px", borderRadius: 999 }}
                    >
                      <Icon name="check" width={14} height={14} style={{ color: "#10B981" }} /> {t.otpVerified}
                    </motion.div>
                  ) : (
                    <span style={{ fontSize: 11, color: "#9CA3AF", fontWeight: 500 }}>{t.waitingAadhaar}</span>
                  )}
                </div>

                {/* Center Gap OR Divider */}
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 8, padding: "0 8px" }}>
                  <div style={{ width: 1, flex: 1, borderLeft: "1.5px dashed #E5E7EB" }} />
                  <span style={{ fontSize: 10, fontWeight: 800, color: "#9CA3AF", background: "#F9FAFB", padding: "4px 8px", borderRadius: 12 }}>OR</span>
                  <div style={{ width: 1, flex: 1, borderLeft: "1.5px dashed #E5E7EB" }} />
                </div>

                {/* Right Side: Biometric */}
                <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 14, minWidth: 200 }}>
                  <span style={{ fontWeight: 800, color: "#4B5563", fontSize: 11, letterSpacing: "0.08em" }}>{t.biometricDevice}</span>

                  {/* Fingerprint device scanner container */}
                  <DermalFingerprintScanner progress={biometricProgress} success={biometricProgress === 100} />

                  {/* Progress Line */}
                  <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
                    <div style={{ width: "80%", height: 6, background: "#E5E7EB", borderRadius: 3, position: "relative" }}>
                      <div style={{ width: `${biometricProgress}%`, height: "100%", background: biometricProgress === 100 ? "#10B981" : "linear-gradient(90deg, #0A9E9A, #6DE7E0)", transition: "width 0.1s linear", borderRadius: 3 }} />

                      {/* Spark at the tip */}
                      {biometricProgress > 0 && biometricProgress < 100 && (
                        <div style={{
                          position: "absolute",
                          left: `calc(${biometricProgress}% - 4px)`,
                          top: -1,
                          width: 8,
                          height: 8,
                          borderRadius: "50%",
                          background: "#fff",
                          boxShadow: "0 0 8px 3px rgba(10, 158, 154, 0.6)",
                          transition: "left 0.1s linear"
                        }} />
                      )}
                    </div>
                  </div>

                  {biometricProgress === 100 ? (
                    <motion.div
                      initial={{ scale: 0.9, opacity: 0 }}
                      animate={{ scale: 1, opacity: 1 }}
                      style={{ display: "flex", alignItems: "center", gap: 6, color: "#10B981", fontWeight: 800, fontSize: 12, background: "#E6F4EA", padding: "6px 16px", borderRadius: 999 }}
                    >
                      <Icon name="check" width={14} height={14} style={{ color: "#10B981" }} /> {t.fingerprintMatch}
                    </motion.div>
                  ) : (
                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#FFB020", animation: "pulse-opacity 1.2s infinite" }} />
                      <span style={{ fontSize: 11, fontWeight: 700, color: "#4B5563" }}>{t.livenessScan} {biometricProgress}%</span>
                    </div>
                  )}
                </div>

              </div>
            </motion.div>
          )}

          {simStep === 3 && (
            <motion.div
              key="step3"
              initial={{ opacity: 0, scale: 0.95, y: 10 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95, y: -10 }}
              transition={{ duration: 0.4 }}
              style={{ width: "100%", maxWidth: 400, background: "#fff", border: "1px solid rgba(11,23,51,0.06)", borderRadius: 20, padding: "20px 24px", boxShadow: "0 20px 40px rgba(11,23,51,0.06)", overflow: "hidden", position: "relative" }}
            >
              <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                {/* Header Section */}
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <div style={{ width: 36, height: 36, borderRadius: 10, background: "rgba(16, 185, 129, 0.1)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Icon name="user" width={18} height={18} style={{ color: "#10B981" }} />
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ fontWeight: 800, color: "#111827", fontSize: 13, letterSpacing: "0.04em" }}>{t.createPhr}</span>
                    <span style={{ color: "#6B7280", fontSize: 11 }}>{t.personalHealthId}</span>
                  </div>
                </div>

                {/* Input Section */}
                <div>
                  <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#4B5563", marginBottom: 6 }}>{t.chooseAbhaAddress}</label>
                  <motion.div
                    animate={abhaText.length === 12 ? { borderColor: "#10B981", boxShadow: "0 0 0 4px rgba(16, 185, 129, 0.1)" } : { borderColor: "#D1D5DB", boxShadow: "0 0 0 0px transparent" }}
                    transition={{ duration: 0.3 }}
                    style={{ display: "flex", width: "100%", border: "1.5px solid", borderRadius: 10, overflow: "hidden", background: "#fff" }}
                  >
                    <div style={{ flex: 1, padding: "8px 12px", display: "flex", alignItems: "center", gap: 8 }}>
                      <Icon name="mail" width={16} height={16} style={{ color: "#9CA3AF" }} />
                      <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
                        <span style={{ fontWeight: 700, color: "#111827", fontSize: 14 }}>{abhaText}</span>
                        {abhaText.length < 12 && isPlaying && (
                          <motion.div animate={{ opacity: [0, 1, 0] }} transition={{ duration: 0.8, repeat: Infinity }} style={{ width: 2, height: 18, background: "#0A9E9A", marginLeft: 2 }} />
                        )}
                      </div>
                    </div>
                    <div style={{ background: "linear-gradient(to right, #F3F4F6, #E5E7EB)", padding: "8px 14px", display: "flex", alignItems: "center", borderLeft: "1px solid #D1D5DB" }}>
                      <span style={{ color: "#4B5563", fontWeight: 800, fontSize: 13, letterSpacing: "0.02em" }}>@abdm</span>
                    </div>
                  </motion.div>
                </div>

                {/* Suggestions Section */}
                <div style={{ height: 90, display: "flex", alignItems: "center" }}>
                  {abhaText.length === 12 ? (
                    <motion.div
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.4 }}
                      style={{ display: "flex", flexDirection: "column", gap: 12 }}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#10B981", fontSize: 12, fontWeight: 800, background: "rgba(16, 185, 129, 0.08)", padding: "8px 14px", borderRadius: 8 }}>
                        <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: "spring", delay: 0.2 }}>
                          <Icon name="check" width={16} height={16} style={{ color: "#10B981" }} />
                        </motion.div>
                        {t.available}
                      </div>

                      <div>
                        <span style={{ fontSize: 10, color: "#6B7280", fontWeight: 700, marginBottom: 8, display: "block" }}>{t.otherSuggestions}</span>
                        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                          <motion.span initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: 0.3 }} style={{ fontSize: 11, background: "#F3F4F6", color: "#4B5563", padding: "6px 12px", borderRadius: 8, fontWeight: 600, border: "1px solid #E5E7EB" }}>rahul.sharma1988@abdm</motion.span>
                          <motion.span initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: 0.4 }} style={{ fontSize: 11, background: "#F3F4F6", color: "#4B5563", padding: "6px 12px", borderRadius: 8, fontWeight: 600, border: "1px solid #E5E7EB" }}>rahuls@abdm</motion.span>
                        </div>
                      </div>
                    </motion.div>
                  ) : (
                    <div style={{ display: "flex", alignItems: "center", gap: 8, height: "100%", opacity: 0.6, paddingTop: 10 }}>
                      <motion.div animate={{ rotate: 360 }} transition={{ duration: 2, repeat: Infinity, ease: "linear" }}>
                        <Icon name="network" width={16} height={16} style={{ color: "#6B7280" }} />
                      </motion.div>
                      <span style={{ fontSize: 11, color: "#6B7280", fontWeight: 600 }}>{t.queryingPhr}</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Background accent graphic */}
              <div style={{ position: "absolute", right: -30, top: -30, opacity: 0.03, pointerEvents: "none" }}>
                <Icon name="user" width={120} height={120} />
              </div>
            </motion.div>
          )}

          {simStep === 4 && (
            <motion.div
              key="step4"
              initial={{ opacity: 0, scale: 0.95, y: 10 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95, y: -10 }}
              transition={{ duration: 0.4 }}
              style={{ width: "100%", maxWidth: 440, display: "flex", flexDirection: "column", alignItems: "center", gap: 20, background: "#fff", border: "1px solid rgba(11,23,51,0.06)", borderRadius: 20, padding: "20px 24px", boxShadow: "0 20px 40px rgba(11,23,51,0.06)" }}
            >
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
                <span style={{ fontWeight: 800, color: "#111827", fontSize: 13, letterSpacing: "0.04em", textTransform: "uppercase" }}>{t.linkingChikitsa}</span>
                <span style={{ fontSize: 11, color: "#6B7280" }}>{t.establishingEncrypted}</span>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: 16, position: "relative", width: "100%", justifyContent: "center" }}>
                {/* Registry Node */}
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10, width: 80, zIndex: 2 }}>
                  <AbhaRegistryNodeMini t={t} />
                  <span style={{ fontSize: 10, fontWeight: 800, textAlign: "center", color: "#4B5563" }}>{t.abhaRegistry}</span>
                </div>

                {/* SVG Connecting Line with Flow */}
                <div style={{ flex: 1, position: "relative", height: 24, display: "flex", alignItems: "center" }}>
                  <svg width="100%" height="100%" preserveAspectRatio="none">
                    <line x1="0" y1="12" x2="100%" y2="12" stroke="#E5E7EB" strokeWidth="4" strokeLinecap="round" strokeDasharray="8 6" />
                    {linkingProgress > 0 && (
                      <line x1="0" y1="12" x2={`${linkingProgress}%`} y2="12" stroke="url(#linkGrad)" strokeWidth="4" strokeLinecap="round" strokeDasharray="8 6" style={{ animation: "dash-flow 0.5s linear infinite" }} />
                    )}
                    <defs>
                      <linearGradient id="linkGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stopColor="#0A9E9A" />
                        <stop offset="100%" stopColor="#10B981" />
                      </linearGradient>
                    </defs>
                  </svg>

                  {/* Floating secure packet */}
                  {linkingProgress > 0 && linkingProgress < 100 && (
                    <motion.div
                      animate={{ left: ["0%", "100%"] }}
                      transition={{ duration: 1.2, repeat: Infinity, ease: "linear" }}
                      style={{ position: "absolute", top: "50%", marginTop: -12, width: 24, height: 24, borderRadius: 8, background: "#fff", border: "1.5px solid #10B981", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 4px 12px rgba(16,185,129,0.4)" }}
                    >
                      <Icon name="shield" width={14} height={14} style={{ color: "#10B981" }} />
                    </motion.div>
                  )}
                </div>

                {/* Local EMR Node */}
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10, width: 80, zIndex: 2 }}>
                  <LocalHimsNodeMini linkingProgress={linkingProgress} t={t} />
                  <span style={{ fontSize: 10, fontWeight: 800, textAlign: "center", color: "#4B5563" }}>{t.chikitsaHims}</span>
                </div>
              </div>

              <div style={{ height: 60, display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
                {linkingProgress === 100 ? (
                  <motion.div
                    initial={{ scale: 0.9, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    style={{ display: "flex", flexDirection: "column", gap: 6, alignItems: "center", background: "rgba(16, 185, 129, 0.08)", padding: "8px 20px", borderRadius: 12, border: "1px solid rgba(16, 185, 129, 0.2)", width: "100%" }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      <Icon name="check" width={16} height={16} style={{ color: "#10B981" }} />
                      <span style={{ fontSize: 13, fontWeight: 800, color: "#10B981" }}>{t.uhidConfigured}</span>
                    </div>
                    <span style={{ fontSize: 11, fontFamily: "var(--font-mono), monospace", color: "#065F5C", background: "#fff", padding: "4px 10px", borderRadius: 6, fontWeight: 700, boxShadow: "0 2px 4px rgba(0,0,0,0.02)" }}>UHID: CH-2026-8942</span>
                  </motion.div>
                ) : (
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <motion.div animate={{ rotate: 360 }} transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}>
                      <Icon name="network" width={14} height={14} style={{ color: "#6B7280" }} />
                    </motion.div>
                    <span style={{ fontSize: 11, color: "#6B7280", fontWeight: 600 }}>{t.syncingCredentials} {linkingProgress}%</span>
                  </div>
                )}
              </div>
            </motion.div>
          )}

          {simStep === 5 && (
            <motion.div
              key="step5"
              initial={{ scale: 0.9, opacity: 0, rotateY: 15 }}
              animate={{ scale: 1, opacity: 1, rotateY: 0 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ type: "spring", stiffness: 180, damping: 18 }}
              style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", gap: 16 }}
            >
              <MicroConfetti />

              {/* Premium Holographic ABHA ID Card */}
              <div
                className="holo-card-premium"
                style={{
                  width: "100%",
                  maxWidth: 390,
                  height: 220,
                  background: "linear-gradient(135deg, #FFF9F2 0%, #FFFFFF 50%, #EEFDFC 100%)",
                  borderRadius: 14,
                  border: "1px solid rgba(11,23,51,0.12)",
                  boxShadow: "0 25px 50px rgba(11,23,51,0.1), inset 0 1px 0 #fff",
                  display: "flex",
                  flexDirection: "column",
                  padding: "10px 14px",
                  position: "relative",
                  overflow: "hidden"
                }}
              >
                {/* ashoka chakra backdrop water mark */}
                <div style={{
                  position: "absolute",
                  left: "50%",
                  top: "50%",
                  width: 140,
                  height: 140,
                  opacity: 0.035,
                  pointerEvents: "none",
                  animation: "rotate-chakra 40s linear infinite",
                  color: "#000088"
                }}>
                  <svg width="140" height="140" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="0.8">
                    <circle cx="12" cy="12" r="10" strokeDasharray="1.5 1" />
                    <circle cx="12" cy="12" r="3" />
                    <path d="M12 2v20M2 12h20M5 5l14 14M5 19L19 5" />
                  </svg>
                </div>

                {/* Flag Band Header */}
                <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 3.5, display: "flex" }}>
                  <div style={{ flex: 1, background: "#FF9933" }} />
                  <div style={{ flex: 1, background: "#FFFFFF" }} />
                  <div style={{ flex: 1, background: "#138808" }} />
                </div>

                {/* Card Title section */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1.5px solid rgba(11,23,51,0.06)", paddingBottom: 6, paddingTop: 4, zIndex: 2 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    <div style={{ width: 15, height: 15, borderRadius: "50%", background: "#0A9E9A", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <Icon name="check" width={9} height={9} style={{ color: "#fff" }} />
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span style={{ fontSize: 7, fontWeight: 900, color: "#FF9933", letterSpacing: "0.04em", lineHeight: 1 }}>NATIONAL HEALTH AUTHORITY</span>
                      <span style={{ fontSize: 6.5, fontWeight: 800, color: "#138808", letterSpacing: "0.04em", lineHeight: 1 }}>राष्ट्रीय स्वास्थ्य प्राधिकरण</span>
                    </div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                    <span style={{ fontSize: 8.5, fontWeight: 900, color: "#0A9E9A" }}>ABHA (Ayushman Bharat Health Account)</span>
                    <span style={{ fontSize: 7, fontWeight: 700, color: "#6B7280" }}>Ministry of Health & Family Welfare</span>
                  </div>
                </div>

                {/* Main Identity Content */}
                <div style={{ flex: 1, display: "flex", gap: 14, paddingTop: 8, alignItems: "center", zIndex: 2 }}>
                  {/* Photo Column */}
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
                    <div style={{
                      width: 68, height: 80, borderRadius: 8, border: "1px solid rgba(11,23,51,0.12)", overflow: "hidden",
                      background: "linear-gradient(180deg, #E6F2F2 0%, #C9E8E8 100%)", display: "flex", alignItems: "center", justifyContent: "center", position: "relative",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.05)"
                    }}>
                      {/* Avatar representation */}
                      <svg width="68" height="80" viewBox="0 0 100 120" fill="none" style={{ display: "block" }}>
                        <defs>
                          <linearGradient id="avatarBg" x1="0" y1="0" x2="100" y2="120" gradientUnits="userSpaceOnUse">
                            <stop offset="0%" stopColor="#F1F5F9" />
                            <stop offset="100%" stopColor="#CBD5E1" />
                          </linearGradient>
                          <linearGradient id="hairGrad" x1="0" y1="0" x2="0" y2="120" gradientUnits="userSpaceOnUse">
                            <stop offset="0%" stopColor="#334155" />
                            <stop offset="100%" stopColor="#0F172A" />
                          </linearGradient>
                          <linearGradient id="suitGrad" x1="0" y1="0" x2="100" y2="120" gradientUnits="userSpaceOnUse">
                            <stop offset="0%" stopColor="#0F766E" />
                            <stop offset="100%" stopColor="#115E59" />
                          </linearGradient>
                        </defs>
                        <rect width="100" height="120" fill="url(#avatarBg)" />
                        <path d="M12 115 C 12 85, 30 75, 50 75 C 70 75, 88 85, 88 115 Z" fill="url(#suitGrad)" />
                        <path d="M40 75 L 50 90 L 60 75 Z" fill="#FFFFFF" />
                        <path d="M48 84 L 52 84 L 54 115 L 46 115 Z" fill="#0A9E9A" />
                        <rect x="42" y="58" width="16" height="18" fill="#FFEDD5" />
                        <circle cx="50" cy="40" r="20" fill="#FFEDD5" />
                        <path d="M30 40 C 30 20, 70 20, 70 40 C 74 28, 62 18, 50 18 C 38 18, 26 28, 30 40 Z" fill="url(#hairGrad)" />
                        <path d="M29 38 L 31 43 L 33 38 Z" fill="url(#hairGrad)" />
                        <path d="M71 38 L 69 43 L 67 38 Z" fill="url(#hairGrad)" />
                      </svg>
                      {/* Verified overlay */}
                      <div style={{ position: "absolute", bottom: 3, right: 3, width: 14, height: 14, borderRadius: "50%", background: "#10B981", border: "1.5px solid #fff", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 2px 5px rgba(0,0,0,0.1)" }}>
                        <Icon name="check" width={8} height={8} style={{ color: "#fff" }} />
                      </div>
                    </div>
                    <span style={{ fontSize: 7, fontWeight: 900, color: "#10B981", letterSpacing: "0.08em" }}>Verified / सत्यापित</span>
                  </div>

                  {/* Demographic Details Column */}
                  <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 3.5 }}>
                    <div>
                      <div style={{ fontSize: 6.5, color: "#6B7280", fontWeight: 700, lineHeight: 1 }}>Name / नाम</div>
                      <div style={{ fontSize: 11, fontWeight: 900, color: "#111827" }}>Rahul Sharma</div>
                    </div>
                    <div>
                      <div style={{ fontSize: 6.5, color: "#6B7280", fontWeight: 700, lineHeight: 1 }}>ABHA Number / आभा संख्या</div>
                      <div style={{ fontSize: 12, fontWeight: 900, color: "#0A9E9A", fontFamily: "var(--font-mono), monospace", letterSpacing: "0.06em" }}>91-7489-3210-9482</div>
                    </div>
                    <div style={{ display: "flex", gap: 12 }}>
                      <div>
                        <div style={{ fontSize: 6.5, color: "#6B7280", fontWeight: 700, lineHeight: 1 }}>Gender / लिंग</div>
                        <div style={{ fontSize: 8.5, fontWeight: 800, color: "#111827" }}>Male / पुरुष</div>
                      </div>
                      <div>
                        <div style={{ fontSize: 6.5, color: "#6B7280", fontWeight: 700, lineHeight: 1 }}>Date of Birth / जन्म तिथि</div>
                        <div style={{ fontSize: 8.5, fontWeight: 800, color: "#111827" }}>15-08-1988</div>
                      </div>
                    </div>
                    <div>
                      <div style={{ fontSize: 6.5, color: "#6B7280", fontWeight: 700, lineHeight: 1 }}>ABHA Address / आभा पता</div>
                      <div style={{ fontSize: 9.5, fontWeight: 900, color: "#4B5563", fontFamily: "var(--font-mono), monospace" }}>rahul.sharma@abdm</div>
                    </div>
                  </div>

                  {/* QR Code and Emblem Column */}
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", justifyContent: "space-between", height: "100%", gap: 6, zIndex: 2 }}>
                    {/* Simulated QR Code */}
                    <div style={{
                      width: 54, height: 54, border: "1px solid rgba(0,0,0,0.08)", padding: 4, borderRadius: 4,
                      background: "#fff", display: "flex", flexDirection: "column", gap: 1, boxShadow: "0 2px 6px rgba(0,0,0,0.03)"
                    }}>
                      <svg viewBox="0 0 29 29" fill="black" width="100%" height="100%" style={{ display: "block" }}>
                        <rect x="0" y="0" width="7" height="7" />
                        <rect x="1" y="1" width="5" height="5" fill="white" />
                        <rect x="2" y="2" width="3" height="3" />
                        <rect x="22" y="0" width="7" height="7" />
                        <rect x="23" y="1" width="5" height="5" fill="white" />
                        <rect x="24" y="2" width="3" height="3" />
                        <rect x="0" y="22" width="7" height="7" />
                        <rect x="1" y="23" width="5" height="5" fill="white" />
                        <rect x="2" y="24" width="3" height="3" />
                        <rect x="20" y="20" width="5" height="5" />
                        <rect x="21" y="21" width="3" height="3" fill="white" />
                        <rect x="22" y="22" width="1" height="1" />
                        <rect x="8" y="0" width="1" height="1" /><rect x="10" y="0" width="2" height="1" /><rect x="13" y="0" width="1" height="1" /><rect x="15" y="0" width="1" height="1" /><rect x="17" y="0" width="3" height="1" /><rect x="21" y="0" width="1" height="1" />
                        <rect x="8" y="1" width="2" height="1" /><rect x="12" y="1" width="1" height="1" /><rect x="14" y="1" width="2" height="1" /><rect x="18" y="1" width="1" height="1" /><rect x="20" y="1" width="2" height="1" />
                        <rect x="9" y="2" width="1" height="1" /><rect x="11" y="2" width="3" height="1" /><rect x="16" y="2" width="2" height="1" /><rect x="20" y="2" width="1" height="1" />
                        <rect x="8" y="3" width="3" height="1" /><rect x="13" y="3" width="1" height="1" /><rect x="15" y="3" width="2" height="1" /><rect x="19" y="3" width="2" height="1" />
                        <rect x="9" y="4" width="1" height="1" /><rect x="11" y="4" width="1" height="1" /><rect x="14" y="4" width="3" height="1" /><rect x="18" y="4" width="1" height="1" /><rect x="20" y="4" width="1" height="1" />
                        <rect x="8" y="5" width="2" height="1" /><rect x="12" y="5" width="2" height="1" /><rect x="16" y="5" width="1" height="1" /><rect x="19" y="5" width="1" height="1" /><rect x="21" y="5" width="1" height="1" />
                        <rect x="8" y="6" width="1" height="1" /><rect x="10" y="6" width="3" height="1" /><rect x="15" y="6" width="2" height="1" /><rect x="18" y="6" width="2" height="1" /><rect x="21" y="6" width="1" height="1" />
                        <rect x="0" y="8" width="1" height="1" /><rect x="3" y="8" width="2" height="1" /><rect x="6" y="8" width="2" height="1" /><rect x="9" y="8" width="1" height="1" /><rect x="11" y="8" width="2" height="1" /><rect x="15" y="8" width="3" height="1" /><rect x="19" y="8" width="1" height="1" /><rect x="22" y="8" width="2" height="1" /><rect x="25" y="8" width="1" height="1" /><rect x="27" y="8" width="2" height="1" />
                        <rect x="1" y="9" width="2" height="1" /><rect x="5" y="9" width="1" height="1" /><rect x="8" y="9" width="3" height="1" /><rect x="13" y="9" width="1" height="1" /><rect x="16" y="9" width="2" height="1" /><rect x="19" y="9" width="2" height="1" /><rect x="23" y="9" width="1" height="1" /><rect x="26" y="9" width="3" height="1" />
                        <rect x="0" y="10" width="3" height="1" /><rect x="4" y="10" width="2" height="1" /><rect x="8" y="10" width="1" height="1" /><rect x="11" y="10" width="1" height="1" /><rect x="14" y="10" width="2" height="1" /><rect x="17" y="10" width="1" height="1" /><rect x="20" y="10" width="3" height="1" /><rect x="24" y="10" width="2" height="1" /><rect x="28" y="10" width="1" height="1" />
                        <rect x="2" y="11" width="1" height="1" /><rect x="5" y="11" width="3" height="1" /><rect x="9" y="11" width="2" height="1" /><rect x="13" y="11" width="3" height="1" /><rect x="18" y="11" width="1" height="1" /><rect x="21" y="11" width="2" height="1" /><rect x="25" y="11" width="1" height="1" /><rect x="27" y="11" width="1" height="1" />
                        <rect x="0" y="12" width="2" height="1" /><rect x="4" y="12" width="1" height="1" /><rect x="7" y="12" width="2" height="1" /><rect x="10" y="12" width="2" height="1" /><rect x="14" y="12" width="1" height="1" /><rect x="16" y="12" width="3" height="1" /><rect x="20" y="12" width="1" height="1" /><rect x="23" y="12" width="2" height="1" /><rect x="26" y="12" width="2" height="1" />
                        <rect x="1" y="13" width="1" height="1" /><rect x="3" y="13" width="3" height="1" /><rect x="8" y="13" width="1" height="1" /><rect x="11" y="13" width="2" height="1" /><rect x="15" y="13" width="1" height="1" /><rect x="18" y="13" width="2" height="1" /><rect x="22" y="13" width="3" height="1" /><rect x="27" y="13" width="1" height="1" />
                        <rect x="0" y="14" width="3" height="1" /><rect x="5" y="14" width="2" height="1" /><rect x="9" y="14" width="1" height="1" /><rect x="12" y="14" width="2" height="1" /><rect x="16" y="14" width="1" height="1" /><rect x="19" y="14" width="2" height="1" /><rect x="23" y="14" width="1" height="1" /><rect x="25" y="14" width="3" height="1" />
                        <rect x="8" y="15" width="2" height="1" /><rect x="11" y="15" width="1" height="1" /><rect x="14" y="15" width="3" height="1" /><rect x="18" y="15" width="1" height="1" /><rect x="21" y="15" width="2" height="1" /><rect x="24" y="15" width="3" height="1" /><rect x="28" y="15" width="1" height="1" />
                        <rect x="9" y="16" width="1" height="1" /><rect x="12" y="16" width="2" height="1" /><rect x="16" y="16" width="1" height="1" /><rect x="19" y="16" width="2" height="1" /><rect x="22" y="16" width="1" height="1" /><rect x="25" y="16" width="2" height="1" />
                        <rect x="8" y="17" width="3" height="1" /><rect x="13" y="17" width="2" height="1" /><rect x="17" y="17" width="1" height="1" /><rect x="20" y="17" width="3" height="1" /><rect x="24" y="17" width="1" height="1" /><rect x="26" y="17" width="2" height="1" />
                        <rect x="9" y="20" width="2" height="1" /><rect x="13" y="20" width="2" height="1" /><rect x="16" y="20" width="3" height="1" /><rect x="26" y="20" width="2" height="1" />
                        <rect x="8" y="21" width="1" height="1" /><rect x="11" y="21" width="2" height="1" /><rect x="15" y="21" width="1" height="1" /><rect x="18" y="21" width="1" height="1" /><rect x="27" y="21" width="2" height="1" />
                        <rect x="8" y="22" width="2" height="1" /><rect x="12" y="22" width="1" height="1" /><rect x="14" y="22" width="2" height="1" /><rect x="18" y="22" width="1" height="1" /><rect x="26" y="22" width="3" height="1" />
                        <rect x="9" y="23" width="1" height="1" /><rect x="11" y="23" width="3" height="1" /><rect x="16" y="23" width="1" height="1" /><rect x="19" y="23" width="1" height="1" /><rect x="27" y="23" width="1" height="1" />
                        <rect x="8" y="24" width="3" height="1" /><rect x="13" y="24" width="2" height="1" /><rect x="17" y="24" width="1" height="1" /><rect x="26" y="24" width="2" height="1" />
                        <rect x="9" y="25" width="2" height="1" /><rect x="12" y="25" width="1" height="1" /><rect x="14" y="25" width="2" height="1" /><rect x="18" y="25" width="2" height="1" /><rect x="21" y="25" width="1" height="1" /><rect x="27" y="25" width="2" height="1" />
                        <rect x="8" y="26" width="1" height="1" /><rect x="10" y="26" width="3" height="1" /><rect x="15" y="26" width="1" height="1" /><rect x="17" y="26" width="2" height="1" /><rect x="26" y="26" width="1" height="1" /><rect x="28" y="26" width="1" height="1" />
                        <rect x="9" y="27" width="2" height="1" /><rect x="13" y="27" width="2" height="1" /><rect x="16" y="27" width="3" height="1" /><rect x="21" y="27" width="1" height="1" /><rect x="27" y="27" width="2" height="1" />
                        <rect x="8" y="28" width="1" height="1" /><rect x="11" y="28" width="2" height="1" /><rect x="15" y="28" width="1" height="1" /><rect x="18" y="28" width="1" height="1" /><rect x="20" y="28" width="1" height="1" /><rect x="25" y="28" width="3" height="1" />
                      </svg>
                    </div>
                  </div>
                </div>

                {/* Footer Band */}
                <div style={{
                  borderTop: "1px solid rgba(11,23,51,0.06)", paddingTop: 4, display: "flex",
                  justifyContent: "space-between", alignItems: "center", zIndex: 2
                }}>
                  <span style={{ fontSize: 7, fontWeight: 800, color: "#6B7280" }}>Ayushman Bharat Digital Mission (ABDM)</span>
                  <div style={{ display: "flex", gap: 3, alignItems: "center" }}>
                    <div style={{ width: 4, height: 4, borderRadius: "50%", background: "#FF9933" }} />
                    <div style={{ width: 4, height: 4, borderRadius: "50%", background: "#6B7280" }} />
                    <div style={{ width: 4, height: 4, borderRadius: "50%", background: "#138808" }} />
                    <span style={{ fontSize: 6, fontWeight: 800, color: "#4B5563" }}>Govt. of India / भारत सरकार</span>
                  </div>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>


    </div>
  );
}

function OpdNodeMini({ t }: { t: ReturnType<typeof getAbdmDiagramTranslations> }) {
  return (
    <div style={{ width: 72, height: 72, background: "#fff", borderRadius: 12, border: "2px solid #2A9E5B", boxShadow: "0 12px 24px rgba(42,158,91,0.2)", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <div style={{ height: 16, background: "#2A9E5B", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 8px" }}>
        <span style={{ fontSize: 8, color: "#fff", fontWeight: 800 }}>{t.vitals}</span>
        <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#10B981", boxShadow: "0 0 8px #10B981" }} />
      </div>
      <div style={{ flex: 1, position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }}>
        {/* ECG Line Animation */}
        <svg width="100%" height="100%" viewBox="0 0 72 40" preserveAspectRatio="none" style={{ position: "absolute", inset: 0 }}>
          <motion.path
            d="M 0 20 L 20 20 L 25 10 L 30 35 L 35 15 L 40 20 L 72 20"
            fill="none"
            stroke="#2A9E5B"
            strokeWidth="2"
            initial={{ pathLength: 0, opacity: 0 }}
            animate={{ pathLength: 1, opacity: [0, 1, 1, 0] }}
            transition={{ duration: 2.5, repeat: Infinity, ease: "linear" }}
          />
        </svg>
      </div>
    </div>
  );
}

function LabNodeMini() {
  return (
    <div style={{ width: 64, height: 72, background: "#fff", borderRadius: 12, border: "2px solid #2A9E5B", boxShadow: "0 12px 24px rgba(42,158,91,0.2)", position: "relative", overflow: "hidden", display: "flex", flexDirection: "column", alignItems: "center", paddingTop: 8, gap: 4 }}>
      <div style={{ width: 12, height: 4, background: "#2A9E5B", borderRadius: 2 }} />
      <div style={{ width: 24, height: 24, borderRadius: "50%", border: "2px solid #2A9E5B", position: "relative", overflow: "hidden", display: "flex", alignItems: "flex-end", justifyContent: "center" }}>
        {/* Liquid filling */}
        <motion.div
          animate={{ height: ["20%", "80%", "20%"] }}
          transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
          style={{ width: "100%", background: "rgba(42,158,91,0.5)", borderTop: "2px solid #2A9E5B" }}
        />
        {/* Bubbles */}
        <motion.div animate={{ y: [0, -20], opacity: [0, 1, 0] }} transition={{ duration: 1.5, repeat: Infinity, delay: 0.2 }} style={{ position: "absolute", left: 6, bottom: 4, width: 4, height: 4, borderRadius: "50%", background: "#fff" }} />
        <motion.div animate={{ y: [0, -20], opacity: [0, 1, 0] }} transition={{ duration: 1.2, repeat: Infinity, delay: 0.8 }} style={{ position: "absolute", left: 14, bottom: 2, width: 3, height: 3, borderRadius: "50%", background: "#fff" }} />
      </div>
      <div style={{ width: 32, height: 6, background: "rgba(42,158,91,0.2)", borderRadius: 3, marginTop: 2 }} />
      <div style={{ width: 20, height: 6, background: "rgba(42,158,91,0.2)", borderRadius: 3 }} />
    </div>
  );
}

function DischargeNodeMini() {
  return (
    <div style={{ width: 60, height: 76, background: "#fff", borderRadius: 8, border: "2px solid #2A9E5B", boxShadow: "0 12px 24px rgba(42,158,91,0.2)", display: "flex", flexDirection: "column", padding: "10px 8px", gap: 6, position: "relative" }}>
      {/* Folded corner */}
      <div style={{ position: "absolute", top: 0, right: 0, width: 16, height: 16, background: "rgba(42,158,91,0.1)", borderBottomLeftRadius: 8, borderLeft: "2px solid #2A9E5B", borderBottom: "2px solid #2A9E5B" }} />

      <div style={{ width: "80%", height: 6, background: "#2A9E5B", borderRadius: 3 }} />
      <motion.div animate={{ scaleX: [0, 1, 1] }} transition={{ duration: 3, repeat: Infinity, ease: "easeOut" }} style={{ width: "100%", height: 4, background: "rgba(42,158,91,0.4)", borderRadius: 2, originX: 0 }} />
      <motion.div animate={{ scaleX: [0, 1, 1] }} transition={{ duration: 3, repeat: Infinity, ease: "easeOut", delay: 0.3 }} style={{ width: "90%", height: 4, background: "rgba(42,158,91,0.4)", borderRadius: 2, originX: 0 }} />
      <motion.div animate={{ scaleX: [0, 1, 1] }} transition={{ duration: 3, repeat: Infinity, ease: "easeOut", delay: 0.6 }} style={{ width: "60%", height: 4, background: "rgba(42,158,91,0.4)", borderRadius: 2, originX: 0 }} />

      {/* Stamping animation */}
      <motion.div
        animate={{ scale: [3, 1, 1, 3], opacity: [0, 1, 1, 0] }}
        transition={{ duration: 3, repeat: Infinity, times: [0, 0.2, 0.8, 1] }}
        style={{ position: "absolute", bottom: 8, right: 8, width: 20, height: 20, borderRadius: "50%", border: "2px solid #EF4444", color: "#EF4444", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 900, transformOrigin: "center" }}
      >
        <Icon name="check" width={12} height={12} />
      </motion.div>
    </div>
  );
}

function CareContextNodeMini() {
  return (
    <div style={{ width: 80, height: 72, background: "transparent", display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
      {/* Folder Back */}
      <div style={{ position: "absolute", bottom: 4, width: 72, height: 50, background: "rgba(42,158,91,0.2)", borderRadius: 8, border: "2px solid #2A9E5B" }} />

      {/* Documents sliding in */}
      <motion.div
        animate={{ y: [-30, 0, 0, -30], opacity: [0, 1, 1, 0] }}
        transition={{ duration: 4, repeat: Infinity, times: [0, 0.2, 0.8, 1] }}
        style={{ position: "absolute", bottom: 20, width: 44, height: 56, background: "#fff", borderRadius: 4, border: "2px solid #2A9E5B", boxShadow: "0 -4px 12px rgba(42,158,91,0.2)" }}
      >
        <div style={{ width: "70%", height: 4, background: "rgba(42,158,91,0.4)", margin: "8px 6px" }} />
        <div style={{ width: "50%", height: 4, background: "rgba(42,158,91,0.4)", margin: "4px 6px" }} />
      </motion.div>

      {/* Folder Front */}
      <div style={{ position: "absolute", bottom: 4, width: 72, height: 40, background: "#2A9E5B", borderRadius: 8, boxShadow: "0 8px 24px rgba(42,158,91,0.4)", display: "flex", alignItems: "center", justifyContent: "center" }}>
        {/* Locking badge */}
        <motion.div
          animate={{ scale: [0, 1, 1, 0] }}
          transition={{ duration: 4, repeat: Infinity, times: [0, 0.3, 0.7, 1] }}
          style={{ width: 28, height: 28, background: "#fff", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 4px 8px rgba(0,0,0,0.2)" }}
        >
          <Icon name="link" width={16} height={16} style={{ color: "#2A9E5B" }} />
        </motion.div>
      </div>
    </div>
  );
}

function AbhaProfileNodeMini({ t }: { t: ReturnType<typeof getAbdmDiagramTranslations> }) {
  return (
    <div style={{ width: 96, height: 60, background: "#fff", borderRadius: 12, border: "2px solid #2A9E5B", boxShadow: "0 12px 32px rgba(42,158,91,0.3)", position: "relative", overflow: "hidden", display: "flex", flexDirection: "column" }}>
      <div style={{ height: 20, background: "#2A9E5B", display: "flex", alignItems: "center", padding: "0 6px" }}>
        <span style={{ fontSize: 8.5, color: "#fff", fontWeight: 800, letterSpacing: "0.03em", whiteSpace: "nowrap" }}>{t.abhaProfile}</span>
      </div>
      <div style={{ flex: 1, display: "flex", alignItems: "center", padding: "0 12px", gap: 10 }}>
        <Icon name="user" width={24} height={24} style={{ color: "#2A9E5B" }} />
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <span style={{ fontSize: 9, color: "#6B7280", fontWeight: 700 }}>{t.records}</span>
          <motion.div style={{ display: "flex", gap: 4 }}>
            {/* Record dots appearing */}
            <motion.div animate={{ opacity: [0, 1] }} transition={{ duration: 4, repeat: Infinity, times: [0, 0.1] }} style={{ width: 8, height: 8, background: "#2A9E5B", borderRadius: "50%" }} />
            <motion.div animate={{ opacity: [0, 1] }} transition={{ duration: 4, repeat: Infinity, times: [0, 0.3] }} style={{ width: 8, height: 8, background: "#2A9E5B", borderRadius: "50%" }} />
            <motion.div animate={{ opacity: [0, 1] }} transition={{ duration: 4, repeat: Infinity, times: [0, 0.5] }} style={{ width: 8, height: 8, background: "#2A9E5B", borderRadius: "50%" }} />
            <motion.div animate={{ scale: [0, 1.5, 1], opacity: [0, 1, 1] }} transition={{ duration: 4, repeat: Infinity, times: [0, 0.7, 0.8] }} style={{ width: 8, height: 8, background: "#10B981", borderRadius: "50%", boxShadow: "0 0 8px #10B981" }} />
          </motion.div>
        </div>
      </div>
    </div>
  );
}

function DiagramM2({ onComplete, isHovered, isInView, locale = "en" }: { onComplete?: () => void; isHovered?: boolean; isInView?: boolean; locale?: string }) {
  const t = getAbdmDiagramTranslations(locale);
  useEffect(() => {
    if (!isInView) return;
    const timer = setTimeout(() => {
      if (onComplete) {
        onComplete();
      }
    }, 5000);
    return () => clearTimeout(timer);
  }, [onComplete, isInView]);

  return (
    <div style={{ width: "100%", height: "100%", position: "relative" }}>
      <svg width="100%" height="100%" viewBox="0 0 600 300" style={{ position: "absolute", inset: 0, overflow: "visible" }}>
        <FlowLine color="#2A9E5B" delay={0.2} pathD="M 100 60 C 200 60 200 150 300 150" />
        <FlowLine color="#2A9E5B" delay={0.4} pathD="M 100 150 L 300 150" />
        <FlowLine color="#2A9E5B" delay={0.6} pathD="M 100 240 C 200 240 200 150 300 150" />
        <FlowLine color="#2A9E5B" delay={1.0} pathD="M 300 150 L 500 150" />
      </svg>

      <FlowNode label={locale === "hi" ? "ओपीडी और आईपीडी" : "OPD & IPD"} x={100} y={60} delay={0.0} color="#2A9E5B" size={72} labelPosition="left">
        <OpdNodeMini t={t} />
      </FlowNode>
      <FlowNode label={locale === "hi" ? "लैब रिपोर्ट" : "Lab Reports"} x={100} y={150} delay={0.2} color="#2A9E5B" size={72} labelPosition="left">
        <LabNodeMini />
      </FlowNode>
      <FlowNode label={locale === "hi" ? "डिस्चार्ज" : "Discharge"} x={100} y={240} delay={0.4} color="#2A9E5B" size={76} labelPosition="left">
        <DischargeNodeMini />
      </FlowNode>

      <FlowNode label={locale === "hi" ? "केयर कॉन्टेक्स्ट" : "Care Context"} x={300} y={150} delay={0.8} color="#2A9E5B" size={80}>
        <CareContextNodeMini />
      </FlowNode>
      <FlowNode label={locale === "hi" ? "ABHA प्रोफाइल" : "ABHA Profile"} x={500} y={150} delay={1.4} color="#2A9E5B" size={96}>
        <AbhaProfileNodeMini t={t} />
      </FlowNode>

      <motion.div
        initial={{ opacity: 0, scale: 0.8, rotateX: 90, y: 20, x: "-50%" }}
        animate={{ opacity: 1, scale: 1, rotateX: 0, y: 0, x: "-50%" }}
        exit={{ opacity: 0, scale: 0.9, y: 10, x: "-50%", transition: { duration: 0.2 } }}
        transition={{ delay: 2.0, type: "spring", stiffness: 200, damping: 15 }}
        style={{ position: "absolute", bottom: 8, left: "50%", background: "#2A9E5B", color: "#fff", padding: "10px 24px", borderRadius: 999, fontSize: 13, fontWeight: 900, letterSpacing: "0.1em", boxShadow: "0 12px 32px rgba(42,158,91,0.5)", overflow: "hidden" }}
      >
        <motion.div
          animate={{ x: ["-100%", "200%"] }}
          transition={{ duration: 2, repeat: Infinity, repeatDelay: 1, ease: "linear" }}
          style={{ position: "absolute", inset: 0, background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)", zIndex: 1 }}
        />
        <span style={{ position: "relative", zIndex: 2 }}>{t.careContextLinked}</span>
      </motion.div>
    </div>
  );
}



function FlowLineActive({ color, isActive, pathD }: { color: string; isActive: boolean; pathD: string }) {
  return (
    <>
      <path d={pathD} fill="none" stroke="rgba(11,23,51,0.04)" strokeWidth="2.5" strokeDasharray="5 5" />
      <AnimatePresence>
        {isActive && (
          <>
            <motion.path 
              d={pathD} 
              fill="none" 
              stroke={color} 
              strokeWidth="2.5"
              strokeLinecap="round"
              initial={{ pathLength: 0, opacity: 0 }}
              animate={{ pathLength: 1, opacity: 1 }}
              exit={{ opacity: 0, transition: { duration: 0.2 } }}
              transition={{ duration: 0.8, ease: "easeInOut" }}
              style={{ filter: `drop-shadow(0 0 4px ${color}80)` }}
            />
            <motion.path
              d={pathD}
              fill="none"
              stroke="#fff"
              strokeWidth="2.5"
              strokeLinecap="round"
              initial={{ pathLength: 0, pathOffset: 0, opacity: 0 }}
              animate={{ pathLength: 0.2, pathOffset: 1, opacity: [0, 1, 0] }}
              transition={{ duration: 1.5, ease: "linear", repeat: Infinity }}
              style={{ filter: `drop-shadow(0 0 4px #fff)` }}
            />
          </>
        )}
      </AnimatePresence>
    </>
  );
}

function HiuNodeMini({ isActive, t }: { isActive: boolean; t: ReturnType<typeof getAbdmDiagramTranslations> }) {
  return (
    <div style={{
      width: 76,
      height: 76,
      background: "#fff",
      borderRadius: 12,
      border: `2px solid ${isActive ? "#6D28D9" : "#E5E7EB"}`,
      boxShadow: isActive ? "0 8px 24px rgba(109,40,217,0.2)" : "0 8px 16px rgba(0,0,0,0.03)",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      transition: "all 0.4s ease"
    }}>
      <div style={{ height: 16, background: isActive ? "#6D28D9" : "#F3F4F6", display: "flex", alignItems: "center", padding: "0 6px", justifyContent: "space-between", transition: "all 0.4s ease" }}>
        <span style={{ fontSize: 8, color: isActive ? "#fff" : "#6B7280", fontWeight: 800 }}>{t.hiuSystem}</span>
        <div style={{ width: 4, height: 4, borderRadius: "50%", background: isActive ? "#10B981" : "#D1D5DB" }} />
      </div>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", padding: 6, justifyContent: "center", alignItems: "center", gap: 5 }}>
        <Icon name="clipboard" width={22} height={22} style={{ color: isActive ? "#6D28D9" : "#9CA3AF", transition: "all 0.4s ease" }} />
        
        {/* Animated Typing lines inside Clipboard */}
        <div style={{ width: "80%", display: "flex", flexDirection: "column", gap: 2 }}>
          <motion.div 
            animate={isActive ? { width: ["30%", "100%", "30%"] } : { width: "70%" }}
            transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
            style={{ height: 3, background: isActive ? "rgba(109,40,217,0.3)" : "#E5E7EB", borderRadius: 1.5 }} 
          />
          <motion.div 
            animate={isActive ? { width: ["10%", "80%", "10%"] } : { width: "40%" }}
            transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut", delay: 0.3 }}
            style={{ height: 3, background: isActive ? "rgba(109,40,217,0.2)" : "#E5E7EB", borderRadius: 1.5 }} 
          />
        </div>
      </div>
    </div>
  );
}

function GatewayNodeMini({ isActive, t }: { isActive: boolean; t: ReturnType<typeof getAbdmDiagramTranslations> }) {
  return (
    <div style={{
      width: 76,
      height: 76,
      background: "#fff",
      borderRadius: 12,
      border: `2px solid ${isActive ? "#6D28D9" : "#E5E7EB"}`,
      boxShadow: isActive ? "0 8px 24px rgba(109,40,217,0.2)" : "0 8px 16px rgba(0,0,0,0.03)",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      transition: "all 0.4s ease"
    }}>
      <div style={{ height: 16, background: isActive ? "#6D28D9" : "#F3F4F6", display: "flex", alignItems: "center", padding: "0 6px", justifyContent: "space-between", transition: "all 0.4s ease" }}>
        <span style={{ fontSize: 8, color: isActive ? "#fff" : "#6B7280", fontWeight: 800 }}>{t.abdmGw}</span>
        <motion.div
          animate={isActive ? { opacity: [0.3, 1, 0.3] } : {}}
          transition={{ duration: 1, repeat: Infinity }}
          style={{ width: 4, height: 4, borderRadius: "50%", background: isActive ? "#5EEAD4" : "#D1D5DB" }}
        />
      </div>
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
        {/* Central pulsing core */}
        {isActive && (
          <motion.div
            animate={{ scale: [1, 1.4, 1], opacity: [0.2, 0.4, 0.2] }}
            transition={{ duration: 2, repeat: Infinity }}
            style={{ position: "absolute", width: 28, height: 28, borderRadius: "50%", background: "rgba(109,40,217,0.3)" }}
          />
        )}
        <Icon name="network" width={22} height={22} style={{ color: isActive ? "#6D28D9" : "#9CA3AF", transition: "all 0.4s ease", zIndex: 2 }} />
        {isActive && (
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
            style={{ position: "absolute", width: 42, height: 42, borderRadius: "50%", border: "1.5px dashed rgba(109,40,217,0.4)" }}
          />
        )}
      </div>
    </div>
  );
}

function AbhaMobileNodeMini({ step, t }: { step: number; t: ReturnType<typeof getAbdmDiagramTranslations> }) {
  const isRequested = step >= 1;
  const isApproved = step >= 2;
  
  return (
    <div style={{
      width: 64,
      height: 84,
      background: "#111827",
      borderRadius: 12,
      border: `2.5px solid ${isApproved ? "#10B981" : isRequested ? "#6D28D9" : "#4B5563"}`,
      boxShadow: isApproved ? "0 8px 24px rgba(16,185,129,0.25)" : "0 8px 16px rgba(0,0,0,0.12)",
      display: "flex",
      flexDirection: "column",
      padding: 4,
      overflow: "hidden",
      position: "relative",
      transition: "all 0.4s ease"
    }}>
      <div style={{ width: 22, height: 4, background: "#000", borderRadius: 2, margin: "0 auto 4px auto" }} />
      {isRequested ? (
        isApproved ? (
          <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 3 }}>
            <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: "spring" }}>
              <Icon name="check" width={22} height={22} style={{ color: "#10B981" }} />
            </motion.div>
            <span style={{ fontSize: 7, color: "#10B981", fontWeight: 800, textAlign: "center", letterSpacing: "0.02em" }}>{t.approved}</span>
          </div>
        ) : (
          <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 4, justifyContent: "center", position: "relative" }}>
            <span style={{ fontSize: 6.5, color: "#9CA3AF", fontWeight: 800, textAlign: "center" }}>{t.consentRequest}</span>
            <div style={{ width: "90%", height: 3, background: "rgba(255,255,255,0.15)", borderRadius: 1.5, alignSelf: "center" }} />
            
            {/* Action buttons */}
            <div style={{ display: "flex", gap: 3, marginTop: 1, padding: "0 2px", position: "relative" }}>
              <div style={{ flex: 1, height: 9, background: "#EF4444", borderRadius: 2.5, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 5, color: "#fff", fontWeight: 800 }}>{t.deny}</div>
              
              <div style={{ flex: 1, height: 9, background: "#10B981", borderRadius: 2.5, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 5, color: "#fff", fontWeight: 800, position: "relative" }}>
                {t.allow}
                {/* Finger tapping pulse overlay */}
                <motion.div 
                  animate={{ scale: [1, 2.2, 1], opacity: [0.8, 0, 0.8] }}
                  transition={{ duration: 1.2, repeat: Infinity, ease: "easeOut" }}
                  style={{
                    position: "absolute",
                    width: 10,
                    height: 10,
                    borderRadius: "50%",
                    border: "1.5px solid #fff",
                    background: "rgba(255,255,255,0.2)",
                    pointerEvents: "none"
                  }}
                />
              </div>
            </div>
          </div>
        )
      ) : (
        <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 4, opacity: 0.3 }}>
          <Icon name="user" width={20} height={20} style={{ color: "#9CA3AF" }} />
          <span style={{ fontSize: 6.5, color: "#9CA3AF", fontWeight: 800 }}>{t.abhaApp}</span>
        </div>
      )}
    </div>
  );
}

function HipNodeMini({ step, t }: { step: number; t: ReturnType<typeof getAbdmDiagramTranslations> }) {
  const isFetched = step >= 3;
  const isSent = step >= 4;
  const isEncrypting = isFetched && !isSent;
  
  return (
    <div style={{
      width: 76,
      height: 76,
      background: "#fff",
      borderRadius: 12,
      border: `2px solid ${isSent ? "#10B981" : isFetched ? "#6D28D9" : "#E5E7EB"}`,
      boxShadow: isSent ? "0 8px 24px rgba(16,185,129,0.2)" : "0 8px 16px rgba(0,0,0,0.03)",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      position: "relative",
      transition: "all 0.4s ease"
    }}>
      {/* Background Ripple Animation for Encrypting */}
      {isEncrypting && (
        <>
          <motion.div
            animate={{ scale: [0.6, 2.2], opacity: [0.7, 0] }}
            transition={{ duration: 1.8, repeat: Infinity, ease: "easeOut" }}
            style={{
              position: "absolute",
              left: "50%",
              top: "60%",
              width: 60,
              height: 60,
              marginLeft: -30,
              marginTop: -30,
              borderRadius: "50%",
              background: "radial-gradient(circle, rgba(109, 40, 217, 0.3) 0%, transparent 70%)",
              pointerEvents: "none",
              zIndex: 0
            }}
          />
          <motion.div
            animate={{ scale: [0.6, 2.2], opacity: [0.7, 0] }}
            transition={{ duration: 1.8, repeat: Infinity, ease: "easeOut", delay: 0.9 }}
            style={{
              position: "absolute",
              left: "50%",
              top: "60%",
              width: 60,
              height: 60,
              marginLeft: -30,
              marginTop: -30,
              borderRadius: "50%",
              background: "radial-gradient(circle, rgba(109, 40, 217, 0.3) 0%, transparent 70%)",
              pointerEvents: "none",
              zIndex: 0
            }}
          />
        </>
      )}

      <div style={{ height: 16, background: isSent ? "#10B981" : isFetched ? "#6D28D9" : "#F3F4F6", display: "flex", alignItems: "center", padding: "0 6px", justifyContent: "space-between", transition: "all 0.4s ease" }}>
        <span style={{ fontSize: 8, color: isSent || isFetched ? "#fff" : "#6B7280", fontWeight: 800 }}>{t.hipServer}</span>
        <div style={{ width: 4, height: 4, borderRadius: "50%", background: isSent ? "#fff" : isFetched ? "#FFB020" : "#D1D5DB" }} />
      </div>
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: 4, gap: 4, position: "relative" }}>
        {isFetched ? (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 2, zIndex: 2 }}>
            <motion.div 
              animate={isSent ? { scale: [1, 1.15, 1] } : { rotate: [0, 360] }} 
              transition={isSent ? { duration: 1.5, repeat: Infinity } : { duration: 2.2, repeat: Infinity, ease: "easeInOut" }}
            >
              <Icon name="lock" width={22} height={22} style={{ color: isSent ? "#10B981" : "#6D28D9" }} />
            </motion.div>
            <span style={{ fontSize: 6.5, color: isSent ? "#10B981" : "#6D28D9", fontWeight: 800, letterSpacing: "0.02em" }}>{isSent ? t.encrypted : t.encrypting}</span>
          </div>
        ) : (
          <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: 4, opacity: 0.35 }}>
            <Icon name="server" width={20} height={20} style={{ color: "#9CA3AF" }} />
            {/* Spinning server rack circular fans */}
            <div style={{ display: "flex", gap: 6 }}>
              <motion.div animate={{ rotate: 360 }} transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }} style={{ width: 6, height: 6, borderRadius: "50%", border: "1px dashed #9CA3AF" }} />
              <motion.div animate={{ rotate: -360 }} transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }} style={{ width: 6, height: 6, borderRadius: "50%", border: "1px dashed #9CA3AF" }} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function ExchangeLedgerNodeMini({ step, t }: { step: number; t: ReturnType<typeof getAbdmDiagramTranslations> }) {
  const isRouting = step >= 2;
  const isEmitted = step >= 4;
  
  return (
    <div style={{
      width: 76,
      height: 76,
      background: "#fff",
      borderRadius: 12,
      border: `2px solid ${isEmitted ? "#10B981" : isRouting ? "#6D28D9" : "#E5E7EB"}`,
      boxShadow: isEmitted ? "0 8px 24px rgba(16,185,129,0.2)" : "0 8px 16px rgba(0,0,0,0.03)",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      transition: "all 0.4s ease"
    }}>
      <div style={{ height: 16, background: isEmitted ? "#10B981" : isRouting ? "#6D28D9" : "#F3F4F6", display: "flex", alignItems: "center", padding: "0 8px", justifyContent: "space-between", transition: "all 0.4s ease" }}>
        {/* Fixed naming length here so it doesn't wrap or break */}
        <span style={{ fontSize: 8, color: isEmitted || isRouting ? "#fff" : "#6B7280", fontWeight: 800 }}>{t.auditLog}</span>
        <div style={{ width: 4, height: 4, borderRadius: "50%", background: isEmitted ? "#fff" : "#D1D5DB" }} />
      </div>
      <div style={{ flex: 1, padding: 6, display: "flex", flexDirection: "column", gap: 4, justifyContent: "center", overflow: "hidden", position: "relative" }}>
        {/* Scrolling logs mockup */}
        <motion.div 
          animate={isRouting ? { y: [-15, 5] } : {}}
          transition={{ duration: 2.5, repeat: Infinity, ease: "linear" }}
          style={{ display: "flex", flexDirection: "column", gap: 3.5, width: "100%" }}
        >
          <div style={{ width: "90%", height: 3.5, background: isEmitted ? "#10B981" : "rgba(109,40,217,0.3)", borderRadius: 1.5 }} />
          <div style={{ width: "70%", height: 3.5, background: isEmitted ? "#10B981" : "rgba(109,40,217,0.2)", borderRadius: 1.5 }} />
          <div style={{ width: "80%", height: 3.5, background: isEmitted ? "#10B981" : "rgba(109,40,217,0.25)", borderRadius: 1.5 }} />
          <div style={{ width: "50%", height: 3.5, background: isEmitted ? "#10B981" : "rgba(109,40,217,0.15)", borderRadius: 1.5 }} />
        </motion.div>
      </div>
    </div>
  );
}

function DiagramM3({ onComplete, isHovered, isInView, locale = "en" }: { onComplete?: () => void; isHovered?: boolean; isInView?: boolean; locale?: string }) {
  const t = getAbdmDiagramTranslations(locale);
  const M3_STEPS_INFO = getM3StepsInfo(locale);
  const [step, setStep] = useState(0);
  
  useEffect(() => {
    if (!isInView) return;
    const timer = setInterval(() => {
      setStep((s) => s + 1);
    }, 2500);
    return () => clearInterval(timer);
  }, [isInView]);

  useEffect(() => {
    if (step >= 5) {
      setStep(0);
      if (onComplete) {
        onComplete();
      }
    }
  }, [step, onComplete]);

  const currentStepInfo = M3_STEPS_INFO[step] || M3_STEPS_INFO[4] || { title: "", desc: "" };

  return (
    <div style={{ width: "100%", height: "100%", position: "relative" }}>
      {/* Active Flow lines */}
      <svg width="100%" height="100%" viewBox="0 0 600 300" style={{ position: "absolute", inset: 0, overflow: "visible" }}>
        {/* Step 1: HIU -> Gateway */}
        <FlowLineActive isActive={step === 0} color="#6D28D9" pathD="M 100 70 L 300 220" />
        
        {/* Step 2: Gateway -> ABHA App */}
        <FlowLineActive isActive={step === 1} color="#6D28D9" pathD="M 300 220 L 300 70" />
        
        {/* Step 3: ABHA App -> Gateway -> HIP */}
        <FlowLineActive isActive={step === 2} color="#6D28D9" pathD="M 300 70 L 300 220" />
        <FlowLineActive isActive={step === 2} color="#6D28D9" pathD="M 300 220 L 500 70" />
        
        {/* Step 5: HIP -> HIU (Direct encrypted data channel) */}
        <FlowLineActive isActive={step === 4} color="#10B981" pathD="M 500 70 L 100 70" />
        {/* Step 5: HIP -> Ledger (Audit trail) */}
        <FlowLineActive isActive={step === 4} color="#6D28D9" pathD="M 500 70 L 500 220" />
      </svg>
 
      {/* Nodes centered on (x, y) coordinates */}
      <FlowNode label={locale === "hi" ? "HIU पोर्टल" : "HIU Portal"} x={100} y={70} delay={0.0} color="#6D28D9" size={76} labelPosition="top">
        <HiuNodeMini isActive={step === 0 || step === 4} t={t} />
      </FlowNode>
 
      <FlowNode label={locale === "hi" ? "ABHA मोबाइल" : "ABHA Mobile"} x={300} y={70} delay={0.2} color="#6D28D9" size={84} labelPosition="top">
        <AbhaMobileNodeMini step={step} t={t} />
      </FlowNode>
 
      <FlowNode label={locale === "hi" ? "HIP स्रोत" : "HIP Source"} x={500} y={70} delay={0.4} color="#6D28D9" size={76} labelPosition="top">
        <HipNodeMini step={step} t={t} />
      </FlowNode>
 
      <FlowNode label={locale === "hi" ? "HIE-CM गेटवे" : "HIE-CM Gateway"} x={300} y={220} delay={0.6} color="#6D28D9" size={76} labelPosition="bottom">
        <GatewayNodeMini isActive={step >= 0 && step <= 2} t={t} />
      </FlowNode>
 
      <FlowNode label={locale === "hi" ? "ऑडिट लेजर" : "Audit Ledger"} x={500} y={220} delay={0.8} color="#6D28D9" size={76} labelPosition="bottom">
        <ExchangeLedgerNodeMini step={step} t={t} />
      </FlowNode>
 
      {/* Floating Info Card */}
      <AnimatePresence mode="wait">
        <motion.div
          key={step}
          initial={{ opacity: 0, y: 10, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -10, scale: 0.95 }}
          transition={{ duration: 0.3 }}
          style={{
            position: "absolute",
            left: "-4%",
            bottom: "2%",
            width: "36%",
            background: "rgba(255, 255, 255, 0.95)",
            backdropFilter: "blur(8px)",
            border: "1.5px solid rgba(109,40,217,0.18)",
            borderRadius: 12,
            padding: "10px 14px",
            boxShadow: "0 10px 30px rgba(11,23,51,0.06)",
            display: "flex",
            flexDirection: "column",
            gap: 4,
            zIndex: 10,
            textAlign: "left"
          }}
        >
          <span style={{ fontSize: 8.5, color: "#6D28D9", fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.06em" }}>
            {t.step} {Math.min(step + 1, 5)} {t.of} 5: {currentStepInfo.title}
          </span>
          <p style={{ margin: 0, fontSize: 11, color: "#4B5563", lineHeight: 1.4, fontWeight: 500 }}>
            {currentStepInfo.desc}
          </p>
        </motion.div>
      </AnimatePresence>


    </div>
  );
}

export function AbdmWorkflowVisualizer({ locale = "en" }: { locale?: string }) {
  const STEPS = getAbdmSteps(locale);
  const [activeStep, setActiveStep] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [isInteracting, setIsInteracting] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const containerRef = useRef<HTMLDivElement>(null);
  // Set to true to ensure animation auto-plays reliably in all viewports and is not blocked by observer failures in production
  const isInView = true;

  const handleComplete = () => {
    setActiveStep((s) => (s + 1) % STEPS.length);
  };

  if (!mounted) {
    return (
      <div style={{ display: "flex", gap: 40, alignItems: "stretch", marginTop: 40, flexWrap: "wrap", minHeight: 480 }}>
        {/* Skeleton Left Pane */}
        <div style={{ flex: "1 1 300px", maxWidth: 400, display: "flex", flexDirection: "column", gap: 16 }}>
          {STEPS.map((step) => (
            <div
              key={step.id}
              style={{
                display: "block",
                padding: "24px",
                borderRadius: "20px",
                border: "2px solid transparent",
                background: "rgba(255,255,255,0.4)",
                minHeight: 110
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
                <span style={{ fontSize: 12, fontWeight: 800, background: "#E5E7EB", color: "#6B7280", padding: "4px 10px", borderRadius: 999 }}>{step.label}</span>
                <span style={{ fontSize: 13, fontWeight: 800, color: "#4B5563", letterSpacing: "0.06em" }}>{step.title}</span>
              </div>
              <p style={{ margin: 0, fontSize: 15, color: "#6B7280", lineHeight: 1.5 }}>
                {step.desc}
              </p>
            </div>
          ))}
        </div>
        {/* Skeleton Right Pane */}
        <div style={{ flex: "2 1 500px", background: "linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 100%)", borderRadius: 32, border: "1px solid rgba(11,23,51,0.06)", minHeight: 400 }} />
      </div>
    );
  }

  return (
    <div
      ref={containerRef}
      className="abdm-visualizer"
      style={{ display: "flex", gap: 40, alignItems: "stretch", marginTop: 40, flexWrap: "wrap" }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => {
        setIsHovered(false);
      }}
    >
      <style>{`
        @keyframes abdm-progress {
          from { width: 0%; }
          to { width: 100%; }
        }

        /* ─── Responsive Visualizer Centering & Scaling Overrides ─── */
        @media (max-width: 991px) {
          .abdm-visualizer {
            flex-direction: column !important;
            gap: 20px !important;
          }
          .abdm-visualizer > div:first-child {
            max-width: none !important;
            width: 100% !important;
            flex: 1 1 auto !important;
            gap: 10px !important;
          }
          .abdm-visualizer button {
            padding: 16px 20px !important;
            border-radius: 16px !important;
            transform: none !important; /* disable translation shift on active button */
          }
          .abdm-diagram-pane {
            padding: 24px !important;
            min-height: 320px !important;
            border-radius: 24px !important;
          }
          .abdm-diagram-viewport {
            position: relative !important;
            width: 100% !important;
            max-width: none !important;
            aspect-ratio: none !important;
            height: 276px !important;
            overflow: hidden !important;
          }
          .abdm-diagram-canvas {
            position: absolute !important;
            top: 50% !important;
            left: 50% !important;
            width: 600px !important;
            height: 300px !important;
            transform: translate(-50%, -50%) scale(0.92) !important;
            transform-origin: center center !important;
          }
        }

        @media (max-width: 680px) {
          .abdm-diagram-viewport {
            height: 252px !important;
          }
          .abdm-diagram-canvas {
            transform: translate(-50%, -50%) scale(0.84) !important;
          }
        }

        @media (max-width: 580px) {
          .abdm-diagram-viewport {
            height: 228px !important;
          }
          .abdm-diagram-canvas {
            transform: translate(-50%, -50%) scale(0.76) !important;
          }
        }

        @media (max-width: 480px) {
          .abdm-diagram-pane {
            padding: 16px !important;
            min-height: 220px !important;
          }
          .abdm-diagram-viewport {
            height: 180px !important;
          }
          .abdm-diagram-canvas {
            transform: translate(-50%, -50%) scale(0.60) !important;
          }
        }

        @media (max-width: 410px) {
          .abdm-diagram-viewport {
            height: 156px !important;
          }
          .abdm-diagram-canvas {
            transform: translate(-50%, -50%) scale(0.52) !important;
          }
        }

        @media (max-width: 360px) {
          .abdm-diagram-viewport {
            height: 132px !important;
          }
          .abdm-diagram-canvas {
            transform: translate(-50%, -50%) scale(0.44) !important;
          }
        }

        @media (max-width: 320px) {
          .abdm-diagram-viewport {
            height: 120px !important;
          }
          .abdm-diagram-canvas {
            transform: translate(-50%, -50%) scale(0.40) !important;
          }
        }
      `}</style>
      {/* Left Pane - List of steps */}
      <div style={{ flex: "1 1 300px", maxWidth: 400, display: "flex", flexDirection: "column", gap: 16 }}>
        {STEPS.map((step, idx) => {
          const isActive = idx === activeStep;
          return (
            <button
              key={step.id}
              onClick={() => {
                setActiveStep(idx);
                // Reset interacting state when changing steps
                setIsInteracting(false);
              }}
              style={{
                display: "block",
                textAlign: "left",
                padding: "24px",
                borderRadius: "20px",
                border: `2px solid ${isActive ? step.color : 'transparent'}`,
                background: isActive ? '#fff' : 'rgba(255,255,255,0.4)',
                boxShadow: isActive ? `0 16px 40px ${step.color}20` : 'none',
                transition: "all 0.4s cubic-bezier(0.16, 1, 0.3, 1)",
                cursor: "pointer",
                transform: isActive ? "scale(1.02) translateX(8px)" : "scale(1) translateX(0)",
                position: "relative",
                overflow: "hidden",
              }}
            >
              {/* Smooth Left Strip Indicator */}
              <div
                style={{
                  position: "absolute",
                  left: -2, top: 24, bottom: 24, width: 4,
                  background: step.color,
                  borderRadius: 2,
                  opacity: isActive ? 1 : 0,
                  transform: isActive ? "scaleY(1)" : "scaleY(0.3)",
                  transition: "all 0.4s cubic-bezier(0.16, 1, 0.3, 1)",
                  transformOrigin: "center"
                }}
              />
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
                <span style={{ fontSize: 12, fontWeight: 800, background: isActive ? step.color : "#E5E7EB", color: isActive ? "#fff" : "#6B7280", padding: "4px 10px", borderRadius: 999, transition: "all 0.4s ease" }}>{step.label}</span>
                <span style={{ fontSize: 13, fontWeight: 800, color: isActive ? step.color : "#4B5563", letterSpacing: "0.06em", transition: "all 0.4s ease" }}>{step.title}</span>
              </div>
              <p style={{ margin: 0, fontSize: 15, color: isActive ? "#111827" : "#6B7280", lineHeight: 1.5, fontWeight: isActive ? 500 : 400, transition: "all 0.4s ease" }}>
                {step.desc}
              </p>

              {/* Active Step Loader Strip */}
              {isActive && (
                <div style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: 3,
                  background: "rgba(11,23,51,0.06)",
                  borderRadius: "0 0 20px 20px",
                  overflow: "hidden"
                }}>
                  <div
                    style={{
                      height: "100%",
                      background: step.color,
                      width: "0%",
                      animationName: "abdm-progress",
                      animationDuration: `${activeStep === 0 ? 25.08 : activeStep === 1 ? 5 : 12.5}s`,
                      animationTimingFunction: "linear",
                      animationFillMode: "forwards",
                      animationPlayState: isInteracting ? "paused" : "running"
                    }}
                  />
                </div>
              )}
            </button>
          );
        })}
      </div>

      {/* Right Pane - Diagram */}
      <div
        className="abdm-diagram-pane"
        style={{
          flex: "2 1 500px",
          background: "linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 100%)",
          borderRadius: 32,
          border: "1px solid rgba(11,23,51,0.06)",
          boxShadow: "inset 0 4px 24px rgba(255,255,255,0.8), 0 24px 48px rgba(11,23,51,0.04)",
          position: "relative",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: 400,
          padding: "40px"
        }}
      >
        <div className="abdm-diagram-viewport" style={{ position: "relative", width: "100%", maxWidth: 600, aspectRatio: "600/300" }}>
          <AnimatePresence mode="wait">
            <motion.div
              key={activeStep}
              initial={{ opacity: 0, scale: 0.95, y: 15 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 1.05, y: -15 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              className="abdm-diagram-canvas"
              style={{ width: "100%", height: "100%", position: "absolute", inset: 0 }}
            >
              {activeStep === 0 && (
                <DiagramM1
                  key={activeStep}
                  onInteractionStart={() => setIsInteracting(true)}
                  onInteractionReset={() => setIsInteracting(false)}
                  onComplete={handleComplete}
                  isHovered={isHovered}
                  isInteracting={isInteracting}
                  isInView={isInView}
                  locale={locale}
                />
              )}
              {activeStep === 1 && <DiagramM2 onComplete={handleComplete} isHovered={isHovered} isInView={isInView} locale={locale} />}
              {activeStep === 2 && <DiagramM3 onComplete={handleComplete} isHovered={isHovered} isInView={isInView} locale={locale} />}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}
